import React, { useEffect, useRef, useState } from 'react';
import {
  LuMessageCircle,
  LuSearch,
  LuSend,
  LuUsersRound,
} from 'react-icons/lu';

const PLATFORM_LOGOS = {
  instagram:
    'https://static.vecteezy.com/system/resources/previews/018/930/415/non_2x/instagram-logo-instagram-icon-transparent-free-png.png',
  bumble:
    'https://logos-world.net/wp-content/uploads/2021/02/Bumble-Emblem.png',
  tiktok:
    'https://cdn.pixabay.com/photo/2021/06/15/12/28/tiktok-6338432_960_720.png',
};

const MAYA_AVATAR =
  'https://i.pinimg.com/1200x/b8/8d/6f/b88d6f9bc27f967e569640c198e6ba8a.jpg';

const PROFILE_PHOTOS = [
  'https://i.pinimg.com/736x/e2/29/76/e22976c6e30d837694dc64bb64cf6df5.jpg',
  'https://i.pinimg.com/736x/3f/5b/d9/3f5bd9d873a2894797d9c8ea3800ad8b.jpg',
  'https://i.pinimg.com/736x/ed/3d/6b/ed3d6bac43d643e86bd6616d853b7dbd.jpg',
  'https://i.pinimg.com/736x/a0/8d/78/a08d7883d28fc74405f52ecd315e54ce.jpg',
  'https://i.pinimg.com/736x/0b/98/ab/0b98ab4a4bc41452f4b49106b0efec7d.jpg',
  'https://i.pinimg.com/736x/4b/f2/36/4bf23614748e0f0021be643258c8185c.jpg',
];

const COMMUNITY_AVATAR =
  'https://i.pinimg.com/736x/c6/9d/73/c69d73ec765795945b1473edaa0f8b26.jpg';

const COMMUNITY_PHOTOS = [
  'https://i.pinimg.com/1200x/a4/6d/81/a46d815cee12dee95b5937d179b4ce31.jpg',
  'https://i.pinimg.com/736x/b4/f4/65/b4f465d7da458b4fcfe53484e4643e38.jpg',
  'https://i.pinimg.com/1200x/90/c9/52/90c9522d4086e6242c60bf000cbd08de.jpg',
  'https://i.pinimg.com/736x/1a/cd/86/1acd8636f25f13c12c65cc12c5a1fe66.jpg',
  'https://i.pinimg.com/736x/ec/79/b1/ec79b108bb35ae7e5d442ad3e888e202.jpg',
];

const OPENING_MESSAGE =
  'Hey, you seem cool! I’m part of an invite-only social club called Tribe, and they just gave members a few invites to share. You seem like you’d be a great fit, so I wanted to offer you one 😊';

const STEPS = [
  {
    type: 'lesson',
    narration:
      'Now that you know what an ideal prospect looks like, where do you find them? Most of your work will be cold outreach. Use Instagram, Bumble BFF, TikTok, and other relevant social platforms to find people who look like a strong fit. You can also invite people you already know, but most of your recruiting will happen through cold outreach.',
  },
  {
  type: 'question',
  prompt:
    'Where should most of your recruiting effort go?',
  choices: [
    {
      value: 'A',
      label:
        'Inviting people you already know personally',
    },
    {
      value: 'B',
      label:
        'Sharing your referral link through public posts and large groups',
    },
    {
      value: 'C',
      label:
        'Finding strong prospects through relevant online platforms and starting individual conversations',
    },
  ],
  correct: 'C',
  explanation:
    'Most recruiting should happen through intentional cold outreach to people who appear to be a strong fit for Tribe.',
},
  {
    type: 'lesson',
    narration:
      'Each platform works a little differently. On Instagram and TikTok, look for relevant pages, such as social clubs, event pages, fitness groups, hobby communities, local lifestyle pages, and community organizations. Go through their followers and the people engaging with their content, identify the ones who look like strong prospects, and message them individually. On Bumble BFF, connect with as many people as you can who fit the target profile, then send them the outreach message once you match.',
  },
  {
  type: 'question',
  prompt:
    'You find a relevant local page on Instagram. What should you do next?',
  choices: [
    {
      value: 'A',
      label:
        'Post your Tribe referral link in the page’s comments',
    },
    {
      value: 'B',
      label:
        'Review the page’s recent posts and message everyone who engages with them',
    },
    {
      value: 'C',
      label:
        'Work down the page’s follower list, quickly scan each profile for fit, and message the strong prospects individually',
    },
  ],
  correct: 'C',
  explanation:
    'Relevant community pages provide a strong pool of prospects. Work through their followers, check for basic fit, and contact people individually.',
},
  {
    type: 'lesson',
    narration:
      'Once you find people who look like a strong fit, DM them individually. Do not simply post a generic Tribe link in large Bumble groups, broad group chats, or comment sections. The invitation works because it feels personal and selected. A mass post feels promotional and does not work.',
  },
  {
  type: 'question',

  prompt: 'What is the best approach on Bumble BFF?',

  choices: [
    {
      value: 'A',
      label:
        'Connect with as many people as possible without checking whether they fit the target profile',
    },
    {
      value: 'B',
      label:
        'Connect with people who appear to fit the target profile, then send the opening message once you match',
    },
    {
      value: 'C',
      label:
        'Only connect with people whose bio specifically says they are looking for new friends',
    },
  ],

  correct: 'B',

  explanation:
    'Quickly look for basic fit, connect with strong prospects, and send the opening message once you match.',
},
];

const INSTAGRAM_TIMINGS = [2800, 6300, 14500, 18700, 21800, 23800, 30000];
const BUMBLE_TIMINGS = [4100, 5400, 15300];
const INTRO_TIMINGS = [3600, 5800, 9000, 16000, 19400];

export default function WhereToFindPeople({
  part,
  Question,
  selected,
  onSelect,
  audioStatus,
  playbackId,
}) {
  const step = STEPS[part];
  const [visualStage, setVisualStage] = useState(0);

  useEffect(() => {
    if (step?.type !== 'lesson' || audioStatus !== 'Playing') {
      return undefined;
    }

    setVisualStage(0);

    const timings =
      part === 0
        ? INTRO_TIMINGS
        : part === 2
        ? INSTAGRAM_TIMINGS
        : part === 4
          ? BUMBLE_TIMINGS
          : [];

    const timers = timings.map((time, index) =>
      window.setTimeout(() => setVisualStage(index + 1), time)
    );

    return () => timers.forEach(window.clearTimeout);
  }, [part, step?.type, audioStatus, playbackId]);

  useEffect(() => {
    if (audioStatus !== 'Complete') return;
    if (part === 0) setVisualStage(INTRO_TIMINGS.length);
    if (part === 2) setVisualStage(INSTAGRAM_TIMINGS.length);
    if (part === 4) setVisualStage(BUMBLE_TIMINGS.length);
  }, [part, audioStatus]);

  if (step.type === 'question') {
    return (
      <Question
        {...step}
        selected={selected}
        onSelect={onSelect}
      />
    );
  }

  return (
    <section className="where-slide">
      <style>{STYLES}</style>

      {part === 0 && (
        <PlatformScene
          stage={visualStage}
          playbackId={playbackId}
        />
      )}
      {part === 2 && <InstagramWalkthrough stage={visualStage} />}
      {part === 4 && <BumbleWarning stage={visualStage} />}
    </section>
  );
}

function PlatformScene({ stage, playbackId }) {
  const [visibleStage, setVisibleStage] = useState(stage);
  const [outgoingStage, setOutgoingStage] = useState(null);
  const visibleStageRef = useRef(stage);

  useEffect(() => {
    if (stage === visibleStageRef.current) return undefined;

    setOutgoingStage(visibleStageRef.current);
    visibleStageRef.current = stage;
    setVisibleStage(stage);

    const timer = window.setTimeout(() => {
      setOutgoingStage(null);
    }, 650);

    return () => window.clearTimeout(timer);
  }, [stage, playbackId]);

  return (
    <div className="first-lesson-transition-shell">
      {outgoingStage !== null && (
        <div
          className="first-lesson-layer is-exiting"
          key={`scene-${outgoingStage}-${playbackId}`}
        >
          <FirstLessonScene stage={outgoingStage} playbackId={playbackId} />
        </div>
      )}

      <div
        className="first-lesson-layer is-entering"
        key={`scene-${visibleStage}-${playbackId}`}
      >
        <FirstLessonScene stage={visibleStage} playbackId={playbackId} />
      </div>
    </div>
  );
}

function FirstLessonScene({ stage, playbackId }) {
  const platforms = [
    { name: 'Instagram', logo: PLATFORM_LOGOS.instagram },
    { name: 'Bumble BFF', logo: PLATFORM_LOGOS.bumble },
    { name: 'TikTok', logo: PLATFORM_LOGOS.tiktok },
  ];

  if (stage === 0) {
    return (
      <div className="living-sentence-scene opening-statement-scene" key={`prospects-${playbackId}`}>
        <div className="opening-statement">
          <InlineWords text="You know what an" />
          <span className="ideal-prospect-lockup">
            <strong>IDEAL PROSPECT</strong>
            <span>
              {PROFILE_PHOTOS.slice(0, 4).map((photo, index) => (
                <img src={photo} alt="" style={{ '--living-index': index }} key={photo} />
              ))}
            </span>
          </span>
          <InlineWords text="looks like." delay={680} />
        </div>
      </div>
    );
  }

  if (stage === 1) {
    return (
      <div className="living-sentence-scene living-question-scene" key="where-find">
        <WordReveal text="Where do you find them?" />
      </div>
    );
  }

  if (stage === 2) {
    return (
      <div className="intro-integrated intro-cold-statement" key="cold-outreach">
        <WordReveal text="Most of your work will be" />
        <div className="inline-cold-outreach">
          <LuMessageCircle />
          <WordReveal
            text="cold outreach."
            delay={400}
            handwritten
          />
        </div>
      </div>
    );
  }

  if (stage === 3) {
    return (
      <div className="living-sentence-scene" key="platform-focus">
        <div className="living-sentence living-platform-sentence">
          <InlineWords text="Use" />
          {platforms.map((platform, index) => (
            <span
              className="living-platform-word"
              style={{ '--living-platform-delay': `${180 + index * 180}ms` }}
              key={platform.name}
            >
              <img src={platform.logo} alt="" />
              <strong>{platform.name}</strong>
            </span>
          ))}
          <InlineWords text="and" delay={720} />
          <span className="living-more-platforms-word">
            <b>+</b>
            <strong>other relevant social platforms</strong>
          </span>
          <InlineWords text="to find strong prospects." delay={1120} />
        </div>
      </div>
    );
  }

  if (stage === 4) {
    return (
      <div className="living-sentence-scene" key="known-people">
        <div className="living-sentence">
          <InlineWords text="You can also invite" />
          <span className="living-contacts-word">
            <LuUsersRound />
            <strong className="selective-handwriting">
              people you already know.
            </strong>
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="living-sentence-scene" key="intro-final">
      <div className="living-sentence living-final-sentence">
        <InlineWords text="But most of your recruiting will happen through" />
        <span className="living-typing-word" aria-label="Someone is typing">
          <i /><i /><i />
        </span>
        <InlineWords
          text="cold outreach."
          delay={720}
          handwritten
        />
      </div>
    </div>
  );
}

function WordReveal({
  text,
  delay = 0,
  handwritten = false,
}) {
  const words = text.split(' ');

  return (
    <h1
      className={[
        'where-word-reveal',
        handwritten ? 'is-handwritten' : '',
      ].join(' ')}
      aria-label={text}
    >
      {words.map((word, index) => (
        <React.Fragment key={`${word}-${index}`}>
          <span
            style={{ '--word-delay': `${delay + index * 90}ms` }}
            aria-hidden="true"
          >
            {word}
          </span>
          {index < words.length - 1 ? ' ' : ''}
        </React.Fragment>
      ))}
    </h1>
  );
}

function InstagramWalkthrough({ stage }) {
  if (stage <= 1) {
    return <InstagramKineticOpening stage={stage} />;
  }

  if (stage === 2) {
    return (
      <div className="instagram-category-scene has-instagram-ui">
        <div className="instagram-category-copy-wrap">
          <InstagramCategoryCopy />
        </div>

        <div className="instagram-real-ui instagram-category-ui">
          <InstagramSearchToCommunityScreen />
        </div>
      </div>
    );
  }

  const copy = {
    3: {
      title: 'Go through their followers.',
      detail: 'Go through the community’s followers and the people engaging with its content.',
    },
    4: {
      title: 'Identify the strong prospects.',
      detail: 'Focus on the people whose profiles look like a genuine fit for Tribe.',
    },
    5: {
      title: 'Message them individually.',
      handwrittenWord: 'individually.',
      detail: 'Send the opening invitation directly to the person you selected.',
    },
    6: {
      title: 'On Bumble BFF, connect with strong fits.',
      detail: 'Connect with as many people as you can who match the target profile.',
    },
    7: {
      title: 'Send the outreach message.',
      detail: 'Use the same direct, individual opening invitation.',
    },
  }[Math.min(stage, 7)];

  return (
    <div className="real-app-lesson instagram-lesson">
      <div className="real-app-copy" key={`instagram-copy-${stage}`}>
        <RealCopyHeadline
          text={copy.title}
          handwrittenWord={copy.handwrittenWord}
        />
        <p>{copy.detail}</p>
      </div>

      <div className="instagram-real-ui">
        <InstagramRealScreen stage={stage} />
      </div>
    </div>
  );
}

function RealCopyHeadline({ text, handwrittenWord = '' }) {
  const words = text.split(' ');

  return (
    <h1 className="real-copy-word-reveal" aria-label={text}>
      {words.map((word, index) => (
        <React.Fragment key={`${word}-${index}`}>
          <span
            className={word === handwrittenWord ? 'selective-handwriting' : ''}
            style={{ '--real-copy-word-delay': `${index * 105}ms` }}
            aria-hidden="true"
          >
            {word}
          </span>
          {index < words.length - 1 ? ' ' : ''}
        </React.Fragment>
      ))}
    </h1>
  );
}

function InstagramKineticOpening({ stage }) {
  const [visibleStage, setVisibleStage] = useState(stage);
  const [outgoingStage, setOutgoingStage] = useState(null);
  const visibleStageRef = useRef(stage);

  useEffect(() => {
    if (stage === visibleStageRef.current) return undefined;

    setOutgoingStage(visibleStageRef.current);
    visibleStageRef.current = stage;
    setVisibleStage(stage);

    const timer = window.setTimeout(() => {
      setOutgoingStage(null);
    }, 650);

    return () => window.clearTimeout(timer);
  }, [stage]);

  return (
    <div className="first-lesson-transition-shell">
      {outgoingStage !== null && (
        <div className="first-lesson-layer is-exiting">
          <InstagramKineticOpeningScene stage={outgoingStage} />
        </div>
      )}

      <div
        className="first-lesson-layer is-entering"
        key={`instagram-opening-${visibleStage}`}
      >
        <InstagramKineticOpeningScene stage={visibleStage} />
      </div>
    </div>
  );
}

function InstagramKineticOpeningScene({ stage }) {
  if (stage === 0) {
    return (
      <div className="living-sentence-scene instagram-kinetic-scene">
        <WordReveal text="Each platform works a little differently." />
      </div>
    );
  }

  return (
    <div className="intro-integrated instagram-search-statement">
      <WordReveal text="On Instagram and TikTok, look for" />

      <div className="inline-cold-outreach inline-relevant-communities">
        <LuSearch aria-hidden="true" />
        <WordReveal
          text="relevant communities."
          delay={520}
          handwritten
        />
      </div>
    </div>
  );
}

function InstagramCategoryCopy() {
  const categories = [
    'social clubs',
    'event pages',
    'fitness groups',
    'hobby communities',
    'local lifestyle pages',
  ];

  return (
    <div className="instagram-category-copy">
      <span className="instagram-category-cue">such as</span>

      <span
        className="instagram-category-flip"
        aria-label={categories.join(', ')}
      >
        {categories.map((category, index) => (
          <strong
            className={
              [
                index === categories.length - 1
                  ? 'is-last'
                  : '',
                category.length > 20
                  ? 'is-long'
                  : category.length > 15
                    ? 'is-medium'
                  : '',
              ].join(' ')
            }
            style={{
              '--category-delay': `${620 + index * 930}ms`,
            }}
            key={category}
            aria-hidden="true"
          >
            {category}
          </strong>
        ))}
      </span>
    </div>
  );
}

function InstagramRealScreen({ stage }) {
  if (stage === 3) return <InstagramFollowersScreen />;
  if (stage === 4) return <InstagramFollowersScreen selecting />;
  if (stage === 5) return <InstagramDmScreen sent />;
  if (stage === 6) return <BumbleBffMatchScreen />;
  return <BumbleBffMatchScreen sent />;
}

function BumbleBffMatchScreen({ sent = false }) {
  if (sent) {
    return <BumbleBffChatScreen />;
  }

  const profiles = [
    {
      name: 'Alexis S.',
      age: 27,
      location: 'Los Angeles',
      image: PROFILE_PHOTOS[1],
      bio: 'Always looking for new restaurants, live music, and people to explore LA with.',
      interests: ['Foodie', 'Concerts', 'Traveling', 'Coffee'],
    },
    {
      name: 'Talia N.',
      age: 26,
      location: 'Culver City',
      image: PROFILE_PHOTOS[3],
      bio: 'New job, new neighborhood, and ready to meet more people around the city.',
      interests: ['Thrifting', 'Art', 'Brunch', 'Movies'],
    },
    {
      name: 'Maya M.',
      age: 28,
      location: 'Los Angeles',
      image: MAYA_AVATAR,
      saysHi: true,
      bio: 'Hi! Just moved to LA and looking to make friends. I love concerts, dinner parties, fashion, and exploring new places.',
      interests: ['Concerts', 'Foodie', 'Fashion', 'Exploring'],
    },
  ];

  return (
    <div className="bff-match-screen bff-discover-screen">
      <div className="bff-discover-tabs">
        <strong>People</strong>

        <span className="bff-round-tab" aria-hidden="true">
          <BffHandIcon />
        </span>

        <span className="bff-round-tab" aria-hidden="true">
          <BffSlidersIcon />
        </span>

        <b>Groups</b>
      </div>

      <div className="bff-discover-feed">
        {profiles.map((profile) => (
          <article className="bff-discover-card" key={profile.name}>
            <img src={profile.image} alt={profile.name} />

            <div className="bff-discover-identity">
              <strong>{profile.name}</strong>
              <span>{profile.age} · {profile.location}</span>

              {profile.saysHi && (
                <small><BffHandIcon /> Says hi!</small>
              )}
            </div>

            <div className="bff-discover-details">
              <p>{profile.bio}</p>

              <button
                type="button"
                aria-label={`Connect with ${profile.name}`}
              >
                <BffHandIcon />
              </button>

              <div className="bff-interest-row">
                {profile.interests.map((interest) => (
                  <span key={interest}>{interest}</span>
                ))}
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}

function BumbleBffChatScreen() {
  return (
    <div className="bff-match-screen bff-chat-screen">
      <div className="bff-chat-header">
        <button type="button" aria-label="Back">‹</button>
        <span><strong>Maya</strong><small>● Offline</small></span>
        <b>•••</b>
      </div>

      <div className="bff-chat-history">
        <img src={MAYA_AVATAR} alt="Maya" />
        <p>This is the beginning of your chat history with Maya</p>
        <div>
          <span>Concerts</span>
          <span>Foodie</span>
          <span>Fashion</span>
        </div>
      </div>

      <div className="bff-sent-message">{OPENING_MESSAGE}</div>

      <div className="bff-chat-composer">
        <button type="button" aria-label="Add">+</button>
        <span>Send a message</span>
        <b aria-hidden="true">☺</b>
        <small>GIF</small>
        <i aria-hidden="true">▧</i>
        <em aria-hidden="true">●</em>
      </div>

      <div className="bff-connected-overlay" aria-hidden="true">
        <strong>You’re connected<br />with Maya</strong>
        <div>
          <img src={MAYA_AVATAR} alt="" />
          <span><BffHandIcon /></span>
        </div>
      </div>
    </div>
  );
}

function BffHandIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M7.2 11V5.8a1.3 1.3 0 0 1 2.6 0v4.1-6a1.3 1.3 0 0 1 2.6 0v5.5-4.6a1.3 1.3 0 0 1 2.6 0v5-3.5a1.3 1.3 0 0 1 2.6 0v6.2c0 4.6-2.6 7.5-7 7.5-3.4 0-5.4-1.8-7.2-5.1L2 12.2a1.5 1.5 0 0 1 2.5-1.6L7.2 14" />
    </svg>
  );
}

function BffSlidersIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M4 7h6m4 0h6M4 17h10m4 0h2" />
      <circle cx="12" cy="7" r="2" />
      <circle cx="16" cy="17" r="2" />
    </svg>
  );
}

function InstagramTopBar({ title, action = '•••' }) {
  return (
    <div className="ig-top-bar">
      <button type="button">‹</button>
      <strong>{title}</strong>
      <span>{action}</span>
    </div>
  );
}

function InstagramSearchToCommunityScreen() {
  return (
    <div className="ig-screen ig-search-to-community">
      <InstagramSearchScreen searching openingTarget />

      <div className="ig-search-community-overlay">
        <InstagramCommunityScreen />
      </div>
    </div>
  );
}

function InstagramSearchScreen({
  searching = false,
  openingTarget = false,
}) {
  const results = [
    ['GW', 'girlswhowalkla', 'Girls Who Walk LA', '18.2K followers'],
    ['SC', 'socialclubla', 'Social Club LA', '9,614 followers'],
    ['FF', 'femalefoodiela', 'Female Foodies LA', '7,321 followers'],
    ['LA', 'lagirlsclub', 'LA Girls Club', '42.8K followers'],
    ['RN', 'runclubgirlsla', 'Run Club Girls LA', '6,808 followers'],
    ['BC', 'bookclubla', 'Book Club LA', '5,102 followers'],
    ['PC', 'picnicclub.la', 'Picnic Club LA', '3,965 followers'],
  ];

  return (
    <div className="ig-screen ig-search-screen">
      <div className="ig-search-header">
        <button type="button">‹</button>
        <div>
          <LuSearch />
          <span className={searching ? 'ig-typed-query' : 'ig-search-placeholder'}>
            {searching ? 'la girls club' : 'Search'}
          </span>
          <b>{searching ? '×' : ''}</b>
        </div>
      </div>
      <div className="ig-search-tabs"><span>For you</span><strong>Profiles</strong><span>Tags</span><span>Places</span></div>
      {searching ? (
        <div className="ig-results-window">
          <div className="ig-account-results is-scrolling">
            {results.map((result, index) => (
              <div
                className={[
                  index === 3 ? 'is-target' : '',
                  openingTarget && index === 3
                    ? 'is-opening-target'
                    : '',
                ].join(' ')}
                key={result[1]}
              >
                <i>{result[0]}</i>
                <span><strong>{result[1]} {index === 3 && <b>✓</b>}</strong><small>{result[2]} · {result[3]}</small></span>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="ig-search-empty"><LuSearch /><strong>Search Instagram</strong><span>Find profiles, communities, and people.</span></div>
      )}
    </div>
  );
}

function InstagramCommunityScreen() {
  return (
    <div className="ig-screen">
      <InstagramTopBar title="lagirlsclub" />
      <div className="ig-community-viewport">
        <div className="ig-community-scroll">
          <div className="ig-profile-summary">
            <img
              className="ig-community-avatar"
              src={COMMUNITY_AVATAR}
              alt="LA Girls Club"
            />
            <div><strong>634</strong><small>posts</small></div>
            <div><strong>42.8K</strong><small>followers</small></div>
            <div><strong>418</strong><small>following</small></div>
          </div>
          <div className="ig-profile-bio"><strong>LA Girls Club</strong><span>Community</span><p>Making Los Angeles feel a little smaller 💌</p></div>
          <div className="ig-profile-actions"><button>Follow</button><button>Message</button><button>⌄</button></div>
          <div className="ig-followed-by"><span>MY</span><span>AS</span><p>Followed by <strong>maya.moves</strong> and 14 others</p></div>
          <div className="ig-grid">{COMMUNITY_PHOTOS.map((photo) => <img src={photo} alt="" key={photo} />)}</div>
        </div>
      </div>
    </div>
  );
}

function InstagramFollowersScreen({ selecting = false }) {
  const people = [
    [PROFILE_PHOTOS[1], 'alexis.s', 'Alexis Smith'],
    [PROFILE_PHOTOS[2], 'julesrunsla', 'Jules Rivera'],
    [PROFILE_PHOTOS[3], 'talia.n', 'Talia Nguyen'],
    [MAYA_AVATAR, 'maya.moves', 'Maya Young'],
    [PROFILE_PHOTOS[4], 'cassidywest', 'Cassidy West'],
    [PROFILE_PHOTOS[5], 'ninaeatsla', 'Nina Patel'],
    [PROFILE_PHOTOS[0], 'sophiaaroundla', 'Sophia Chen'],
    [COMMUNITY_PHOTOS[1], 'livinwithliv', 'Olivia Brooks'],
    [COMMUNITY_PHOTOS[3], 'emilyinmotion', 'Emily Davis'],
    [COMMUNITY_PHOTOS[4], 'camilaexplores', 'Camila Torres'],
  ];
  return (
    <div
      className={[
        'ig-screen',
        'ig-followers-screen',
        selecting ? 'is-selecting-profile' : '',
      ].join(' ')}
    >
      <InstagramTopBar title="Followers" action="" />
      <div className="ig-list-search"><LuSearch /> Search</div>
      <div className="ig-followers-window">
        <div className="ig-followers-list is-scrolling">
        {people.map((person, index) => (
          <div
            className={[
              index === 3 ? 'is-target' : '',
              selecting && index === 3 ? 'is-being-selected' : '',
            ].join(' ')}
            key={person[1]}
          >
            <img src={person[0]} alt="" />
            <span><strong>{person[1]}</strong><small>{person[2]}</small></span>
            <button type="button">View</button>
          </div>
        ))}
        </div>
      </div>

      {selecting && (
        <div className="ig-selected-profile-overlay">
          <InstagramMayaScreen />
        </div>
      )}
    </div>
  );
}

function InstagramMayaScreen() {
  return (
    <div className="ig-screen">
      <InstagramTopBar title="maya.moves" />
      <div className="ig-profile-summary">
        <img className="ig-avatar" src={MAYA_AVATAR} alt="Maya Young" />
        <div><strong>46</strong><small>posts</small></div>
        <div><strong>1,284</strong><small>followers</small></div>
        <div><strong>812</strong><small>following</small></div>
      </div>
      <div className="ig-profile-bio"><strong>Maya Young <small>she/her</small></strong><p>Philly → LA<br />USC · 🩺</p></div>
      <div className="ig-profile-actions"><button>Follow</button><button className="is-message">Message</button><button>⌄</button></div>
      <div className="ig-grid">{PROFILE_PHOTOS.map((photo) => <img src={photo} alt="" key={photo} />)}</div>
    </div>
  );
}

function InstagramDmScreen({ sent }) {
  return (
    <div className="ig-screen ig-dm-screen">
      <div className="ig-dm-header"><button>‹</button><img src={MAYA_AVATAR} alt="" /><span><strong>maya.moves</strong><small>Active now</small></span><b>ⓘ</b></div>
      <div className="ig-dm-profile"><img src={MAYA_AVATAR} alt="" /><strong>Maya Young</strong><small>maya.moves · Instagram</small><button>View profile</button></div>
      <div className="ig-dm-thread">
        {sent && <div className="ig-outgoing-message">{OPENING_MESSAGE}</div>}
      </div>
      <div className="ig-message-composer"><span>{sent ? 'Message…' : OPENING_MESSAGE}</span><button><LuSend /></button></div>
    </div>
  );
}

function InlineWords({
  text,
  delay = 0,
  handwritten = false,
}) {
  const words = text.split(' ');

  return (
    <span
      className={[
        'inline-kinetic-words',
        handwritten ? 'is-handwritten' : '',
      ].join(' ')}
      aria-label={text}
    >
      {words.map((word, index) => (
        <React.Fragment key={`${word}-${index}`}>
          <span style={{ '--word-delay': `${delay + index * 90}ms` }} aria-hidden="true">{word}</span>
          {index < words.length - 1 ? ' ' : ''}
        </React.Fragment>
      ))}
    </span>
  );
}

function BumbleWarning({ stage }) {
  if (stage === 0) {
    return (
      <div className="bff-kinetic-opening">
        <div className="bff-invitation-sentence">
          <InlineWords text="Once you find a strong fit," />
        </div>
      </div>
    );
  }

  if (stage === 1) {
    return (
      <div className="bff-kinetic-opening">
        <div className="bff-individual-message">
          <InlineWords text="Message people" />
          <InlineWords
            text="individually."
            delay={260}
            handwritten
          />
        </div>
      </div>
    );
  }

  if (stage === 2) {
    return (
      <div className="bff-kinetic-opening bff-direct-warning">
        <div className="bff-cycle-warning">
          <InlineWords text="Do not simply post a generic Tribe link in" />
          <span
            className="bff-cycle-destinations"
            aria-label="large Bumble groups, broad group chats, or comment sections"
          >
            <strong>
              <span className="bff-cycle-icon is-bumble">
                <img src={PLATFORM_LOGOS.bumble} alt="" />
              </span>
              large Bumble groups
            </strong>
            <strong>
              <span className="bff-cycle-icon"><LuUsersRound /></span>
              broad group chats
            </strong>
            <strong>
              <span className="bff-cycle-icon"><LuMessageCircle /></span>
              comment sections
            </strong>
          </span>
        </div>
      </div>
    );
  }

  const demoStage = stage - 2;

  return (
    <div className="real-app-lesson bff-lesson">
      <div className="real-app-copy bff-locked-copy">
        <h1 className="bff-final-headline">
          Never send{' '}
          <span className="selective-handwriting">Mass posts</span>
        </h1>
      </div>
      <div className="bff-demo-wrap" key="bff-ui">
        <div className="bff-real-ui">
          <BffGroupChatScreen stage={demoStage} />
        </div>
        {demoStage >= 1 && (
          <div className="bff-static-note">
            <strong>Don’t do this</strong>
            <svg viewBox="0 0 120 92" aria-hidden="true">
              <path d="M108 8C78 10 58 25 49 43C42 56 35 68 16 73" />
              <path d="M29 60L15 74L34 78" />
            </svg>
          </div>
        )}
      </div>
    </div>
  );
}

function BffGroupChatScreen({ stage }) {
  return (
    <div
      className={[
        'bff-screen',
        stage >= 1 ? 'is-focused-post' : '',
      ].join(' ')}
    >
      <div className="bff-room-header">
        <button type="button">‹</button>
        <img src={PROFILE_PHOTOS[1]} alt="LA It Girls" />
        <div><strong>Chat room <b>⌄</b></strong><small><i />22 Online</small></div>
        <LuUsersRound />
      </div>
      <div className="bff-new-banner"><strong>25+ new messages since Aug 21</strong><span>×</span></div>
      <div className={`bff-thread ${stage >= 1 ? 'has-sent' : ''}`}>
        <div className="bff-thread-message"><img src={PROFILE_PHOTOS[2]} alt="" /><div><strong>Alex M.</strong><small>Today at 4:02 PM</small><p>I’m down 🙋‍♀️</p></div></div>
        <div className="bff-new-divider"><strong>New Messages</strong><i /></div>
        <div className="bff-thread-message"><img src={PROFILE_PHOTOS[4]} alt="" /><div><strong>Taylor M.</strong><small>Today at 4:04 PM</small><span className="bff-reply-pill">↩ Who’s first</span><p>👀💕</p></div></div>
        <div className="bff-thread-message"><img src={PROFILE_PHOTOS[0]} alt="" /><div><strong>Azure</strong><small>Today at 4:06 PM</small><p>Wait this actually sounds so fun</p></div></div>
        <div className="bff-thread-message"><img src={PROFILE_PHOTOS[3]} alt="" /><div><strong>Mia R.</strong><small>Today at 4:08 PM</small><p>Who’s going Saturday?</p></div></div>
        {stage >= 1 && <div className="bff-thread-message is-mass"><img src={MAYA_AVATAR} alt="" /><div><strong>You</strong><small>Now</small><p>Join Tribe! Sign up at jointribe.io. Code: GOODCOMPANY</p></div></div>}
      </div>
      <div className="bff-welcome-strip"><span>👋</span><div><strong>Welcome to LA It Girls 💋✨!</strong><small>Send your first message here</small></div><b>×</b></div>
      <div className={`bff-composer ${stage === 1 ? 'is-typing' : ''}`}><button>＋</button><span>{stage === 1 ? <small>Join Tribe! Sign up at jointribe.io. Code: GOODCOMPANY</small> : 'Send a message'}</span><b>☺</b><i>GIF</i><em>▣</em><strong>●</strong></div>
    </div>
  );
}

WhereToFindPeople.title = 'Where to find people';
WhereToFindPeople.steps = STEPS;

const STYLES = `
  .where-slide {
    --lesson-font:
      Inter,
      -apple-system,
      BlinkMacSystemFont,
      "Segoe UI",
      sans-serif;
    --lesson-hero-size: clamp(42px, 5.4vw, 70px);
    --lesson-hero-weight: 820;
    --lesson-hero-tracking: -.045em;

    position: relative;
    width: 100%;
    min-height: 465px;
    overflow: hidden;
    color: #111;
    background: #fff;
    font-family: var(--lesson-font);
    text-rendering: optimizeLegibility;
  }

  .first-lesson-transition-shell,
  .first-lesson-layer {
    position: absolute;
    inset: 0;
  }

  .first-lesson-transition-shell {
    overflow: hidden;
    perspective: 1200px;
  }

  .first-lesson-layer.is-entering {
    z-index: 2;
    animation: first-scene-enter 650ms cubic-bezier(.16,1,.3,1) both;
  }

  .first-lesson-layer.is-exiting {
    z-index: 1;
    pointer-events: none;
    animation: first-scene-exit 650ms cubic-bezier(.4,0,.2,1) both;
  }

  .living-sentence-scene {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 44px clamp(30px, 7vw, 110px);
    box-sizing: border-box;
  }

  .living-sentence {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 12px 17px;
    max-width: 1120px;
    font-size: var(--lesson-hero-size);
    font-weight: var(--lesson-hero-weight);
    letter-spacing: var(--lesson-hero-tracking);
    line-height: 1;
    text-align: center;
  }

  .living-sentence .inline-kinetic-words > span {
    transform: translateY(.28em);
    animation-duration: 420ms;
  }

  .opening-statement {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 12px 17px;
    max-width: 1120px;
    font-size: var(--lesson-hero-size);
    font-weight: var(--lesson-hero-weight);
    letter-spacing: var(--lesson-hero-tracking);
    line-height: 1;
    text-align: center;
  }
  .ideal-prospect-lockup {
    display: inline-flex;
    align-items: center;
    gap: 13px;
    padding: 8px 9px 8px 16px;
    color: #fff;
    background: #111;
    border-radius: 999px;
    opacity: 0;
    transform: translateY(17px) scale(.9);
    animation: ideal-lockup-in 560ms 320ms cubic-bezier(.18,.84,.22,1) forwards;
  }
  .ideal-prospect-lockup > strong { font: inherit; font-size: .76em; letter-spacing: -.045em; white-space: nowrap; }
  .ideal-prospect-lockup > span { display: flex; align-items: center; padding-left: 22px; }
  .ideal-prospect-lockup img {
    width: 48px;
    height: 48px;
    margin-left: -22px;
    object-fit: cover;
    border: 3px solid #111;
    border-radius: 50%;
    opacity: 0;
    transform: translateX(12px) scale(.72);
    animation: ideal-face-in 420ms cubic-bezier(.18,.84,.22,1) forwards;
    animation-delay: calc(500ms + var(--living-index) * 80ms);
  }

  .living-profile-word {
    position: relative;
    display: inline-flex;
    align-items: center;
    min-height: 66px;
    padding-left: 116px;
    white-space: nowrap;
  }
  .living-profile-word img {
    position: absolute;
    left: calc(var(--living-index) * 28px);
    width: 50px;
    height: 50px;
    object-fit: cover;
    border: 3px solid #fff;
    border-radius: 50%;
    opacity: 0;
    transform: translateX(16px) scale(.78);
    animation: living-profile-in 500ms cubic-bezier(.18,.84,.22,1) forwards;
    animation-delay: calc(180ms + var(--living-index) * 80ms);
  }
  .living-profile-word strong {
    font: inherit;
    opacity: 0;
    transform: translateY(.25em);
    animation: living-element-in 480ms 460ms cubic-bezier(.18,.84,.22,1) forwards;
  }

  .living-search-word,
  .living-dm-word {
    display: inline-grid;
    place-items: center;
    width: .95em;
    height: .95em;
    color: #fff;
    background: #111;
    border-radius: 50%;
    opacity: 0;
    transform: scale(.65) rotate(-12deg);
    animation: living-icon-pop 520ms 820ms cubic-bezier(.18,.84,.22,1) forwards;
  }
  .living-search-word svg,
  .living-dm-word svg { width: 47%; height: 47%; stroke-width: 1.55; }

  .living-question-sentence {
    max-width: 1060px;
    font-size: clamp(55px, 8vw, 106px);
    line-height: .86;
  }
  .living-question-scene .living-search-word {
    width: .82em;
    height: .82em;
    animation-delay: 40ms;
  }
  .living-question-scene > .where-word-reveal {
    max-width: 1050px;
    font-size: var(--lesson-hero-size);
    line-height: 1;
  }
  .standalone-question {
    display: grid;
    justify-items: center;
    gap: 6px;
    max-width: 1100px;
    font-size: clamp(54px, 8vw, 106px);
    font-weight: 950;
    letter-spacing: -.075em;
    line-height: .86;
    text-align: center;
  }
  .standalone-question > div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
  }
  .standalone-question .living-search-word {
    width: .78em;
    height: .78em;
    flex: 0 0 auto;
  }

  .living-platform-sentence {
    max-width: 1180px;
    gap: 13px 16px;
    font-size: clamp(30px, 4.2vw, 56px);
  }
  .living-platform-word {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
    opacity: 0;
    transform: translateY(18px) scale(.88);
    animation: living-element-in 500ms cubic-bezier(.18,.84,.22,1) forwards;
    animation-delay: var(--living-platform-delay);
  }
  .living-platform-word img { width: .78em; height: .78em; object-fit: contain; }
  .living-platform-word:nth-of-type(2) img { width: .92em; height: .92em; }
  .living-platform-word strong { font: inherit; }
  .living-la-word,
  .living-contacts-word {
    display: inline-flex;
    align-items: center;
    gap: 9px;
    padding: 7px 13px;
    color: #fff;
    background: #111;
    transform: rotate(-1.2deg) scale(.86);
    opacity: 0;
    animation: living-black-word-in 520ms 920ms cubic-bezier(.18,.84,.22,1) forwards;
  }
  .living-la-word svg,
  .living-contacts-word svg { width: .62em; height: .62em; flex: 0 0 auto; stroke-width: 1.5; }
  .living-la-word strong,
  .living-contacts-word strong { font: inherit; }

  .living-more-platforms-word {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 7px 13px 7px 10px;
    color: #fff;
    background: #111;
    transform: rotate(-1deg) scale(.86);
    opacity: 0;
    animation: living-black-word-in 520ms 900ms cubic-bezier(.18,.84,.22,1) forwards;
  }
  .living-more-platforms-word > i {
    display: none;
  }
  .living-more-platforms-word > b { margin-right: 2px; font-size: 1.08em; line-height: 1; }
  .living-more-platforms-word strong { font: inherit; }

  .living-contacts-word {
    padding: 9px 16px;
    animation-delay: 420ms;
  }

  .living-final-sentence { max-width: 1000px; }
  .living-final-sentence .living-dm-word { animation-delay: 520ms; }
  .living-typing-word {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    align-self: center;
    gap: 5px;
    width: 1.24em;
    height: .68em;
    margin: 0 5px;
    background: #ededed;
    border-radius: 999px;
    opacity: 0;
    transform: translateY(12px) scale(.78);
    animation: typing-bubble-in 500ms 440ms cubic-bezier(.18,.84,.22,1) forwards;
  }
  .living-typing-word::after { content: none; }
  .living-typing-word > i {
    position: relative;
    z-index: 1;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #777;
    animation: living-typing-dot 1050ms ease-in-out infinite;
  }
  .living-typing-word > i:nth-child(2) { animation-delay: 140ms; }
  .living-typing-word > i:nth-child(3) { animation-delay: 280ms; }
  .living-final-sentence > .inline-kinetic-words:last-child {
    font-size: 1.28em;
    line-height: .8;
  }

  .intro-prospects,
  .intro-question,
  .intro-cold-outreach,
  .intro-platform-focus,
  .intro-community,
  .intro-final {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 34px;
    padding: 38px;
    box-sizing: border-box;
  }

  .where-word-reveal {
    max-width: 900px;
    margin: 0;
    font-size: var(--lesson-hero-size);
    font-weight: var(--lesson-hero-weight);
    letter-spacing: var(--lesson-hero-tracking);
    line-height: 1;
    text-align: center;
  }

  .where-word-reveal > span {
    display: inline-block;
    opacity: 0;
    transform: translateY(.36em);
    animation: intro-word-in 380ms cubic-bezier(.18,.84,.22,1) forwards;
    animation-delay: var(--word-delay);
  }

  .selective-handwriting,
  .inline-kinetic-words.is-handwritten,
  .living-contacts-word strong.selective-handwriting {
    display: inline-block;
    font-family: 'Ugly Handwriting', cursive;
    font-size: 1.12em;
    font-weight: 400;
    letter-spacing: -.012em;
    line-height: .86;
  }

  .where-word-reveal.is-handwritten {
    font-family: 'Ugly Handwriting', cursive;
    font-size: clamp(43px, 5.5vw, 72px);
    font-weight: 400;
    letter-spacing: -.012em;
    line-height: .88;
  }

  .intro-prospect-cloud {
    position: relative;
    width: 280px;
    height: 94px;
  }

  .intro-prospect-cloud img {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 76px;
    height: 76px;
    object-fit: cover;
    border: 4px solid #fff;
    border-radius: 50%;
    box-shadow: 0 8px 24px rgba(0,0,0,.12);
    opacity: 0;
    transform: translate(calc(-50% + (var(--prospect-index) - 2) * 47px), -45%) scale(.78);
    animation: intro-prospect-in 520ms cubic-bezier(.18,.84,.22,1) forwards;
    animation-delay: calc(var(--prospect-index) * 90ms);
  }

  .intro-question { gap: 22px; }
  .intro-question-mark { position: relative; display: grid; place-items: center; width: 180px; height: 180px; }
  .intro-question-mark strong {
    position: relative;
    z-index: 2;
    font-size: 145px;
    font-weight: 950;
    line-height: 1;
    letter-spacing: -.1em;
    animation: intro-question-pop 580ms cubic-bezier(.18,.84,.22,1) both;
  }

  .intro-question-mark img {
    position: absolute;
    width: 35px;
    height: 35px;
    object-fit: cover;
    border-radius: 50%;
    opacity: .22;
    transform: rotate(calc((var(--question-index) - 2) * 25deg)) translateY(-78px);
    animation: intro-question-photo 650ms cubic-bezier(.18,.84,.22,1) both;
    animation-delay: calc(var(--question-index) * 65ms);
  }

  .intro-cold-outreach { gap: 43px; }
  .cold-outreach-visual {
    display: grid;
    grid-template-columns: 74px 185px 74px;
    align-items: center;
  }

  .cold-prospect,
  .cold-you {
    display: grid;
    place-items: center;
    width: 70px;
    height: 70px;
    overflow: hidden;
    border: 1px solid #dedede;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 9px 26px rgba(0,0,0,.07);
  }

  .cold-prospect img { width: 100%; height: 100%; object-fit: cover; }
  .cold-you { font-size: 11px; font-weight: 950; }
  .cold-message-line { position: relative; display: flex; align-items: center; justify-content: center; }
  .cold-message-line i { position: absolute; right: 0; left: 0; height: 1px; background: #cecece; transform: scaleX(0); animation: cold-line-in 650ms 300ms ease forwards; }
  .cold-message-line svg { position: relative; width: 33px; height: 33px; padding: 12px; background: #fff; opacity: 0; transform: scale(.6); animation: cold-message-in 480ms 820ms cubic-bezier(.18,.84,.22,1) forwards; }

  .intro-platform-focus { gap: 55px; }
  .intro-platform-focus .where-word-reveal { max-width: 760px; font-size: clamp(33px, 4.4vw, 57px); }
  .intro-platform-focus .where-platforms { width: min(560px, 100%); }

  .intro-community { gap: 48px; }
  .intro-community .where-word-reveal { max-width: 780px; font-size: clamp(34px, 4.5vw, 60px); }
  .intro-community-visual {
    display: grid;
    grid-template-columns: 54px 110px 54px;
    align-items: center;
    gap: 25px;
  }
  .intro-community-visual > svg,
  .intro-community-visual > span {
    display: grid;
    place-items: center;
    width: 52px;
    height: 52px;
    color: #777;
  }
  .intro-community-visual > svg { padding: 14px; box-sizing: border-box; }
  .intro-community-visual > span svg { width: 25px; }
  .intro-community-visual > div {
    display: grid;
    place-items: center;
    gap: 6px;
    width: 108px;
    height: 108px;
    border: 1px solid #d8d8d8;
    border-radius: 50%;
    animation: community-pulse 1600ms ease-in-out infinite;
  }
  .intro-community-visual > div svg { width: 34px; height: 34px; }
  .intro-community-visual > div strong { font-size: 9px; letter-spacing: .1em; }

  .intro-final { gap: 45px; }
  .intro-final .where-word-reveal { max-width: 820px; }
  .intro-final-icons { display: flex; align-items: center; gap: 30px; }
  .intro-final-icons img { width: 43px; height: 43px; object-fit: contain; opacity: 0; animation: where-platform-in 500ms forwards; }
  .intro-final-icons img:nth-child(2) { width: 52px; height: 52px; animation-delay: 100ms; }
  .intro-final-icons img:nth-child(3) { animation-delay: 200ms; }

  .prospect-search-opening,
  .platform-rollcall,
  .known-people-sequence,
  .one-to-one-final {
    position: absolute;
    inset: 0;
    overflow: hidden;
  }

  .prospect-scan-sequence,
  .prospect-question-sequence {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .prospect-scan-sequence {
    flex-direction: column;
    gap: 38px;
    animation: prospect-scan-away 520ms 2850ms cubic-bezier(.55,.05,.68,.53) forwards;
  }

  .prospect-scan-copy {
    display: flex;
    align-items: baseline;
    gap: 16px;
    font-weight: 950;
    letter-spacing: -.065em;
    line-height: .9;
  }
  .prospect-scan-copy span { font-size: clamp(31px, 4vw, 52px); opacity: 0; animation: scan-copy-in 430ms ease forwards; }
  .prospect-scan-copy strong { font-size: clamp(56px, 8vw, 102px); opacity: 0; transform: translateX(45px); animation: scan-copy-in 560ms 180ms cubic-bezier(.18,.84,.22,1) forwards; }

  .prospect-filmstrip {
    position: relative;
    display: flex;
    gap: 9px;
    width: min(830px, 88vw);
    height: 112px;
    overflow: hidden;
    -webkit-mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);
    mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);
  }
  .prospect-filmstrip img {
    flex: 0 0 104px;
    width: 104px;
    height: 104px;
    object-fit: cover;
    border-radius: 50%;
    animation: prospect-film-move 2500ms linear both;
  }
  .prospect-filmstrip i {
    position: absolute;
    top: 0;
    left: 50%;
    width: 104px;
    height: 104px;
    border: 5px solid #111;
    border-radius: 50%;
    box-sizing: border-box;
    transform: translateX(-50%) scale(.82);
    animation: prospect-target-pulse 900ms 1200ms cubic-bezier(.18,.84,.22,1) forwards;
  }

  .prospect-question-sequence {
    gap: clamp(25px, 5vw, 70px);
    opacity: 0;
    transform: scale(.82);
    animation: prospect-question-in 620ms 3000ms cubic-bezier(.18,.84,.22,1) forwards;
  }
  .prospect-search-lens {
    display: grid;
    place-items: center;
    width: clamp(100px, 13vw, 165px);
    height: clamp(100px, 13vw, 165px);
    color: #fff;
    background: #111;
    border-radius: 50%;
    transform: rotate(-12deg);
  }
  .prospect-search-lens svg { width: 48%; height: 48%; stroke-width: 1.6; }
  .prospect-question-sequence > div:last-child { display: grid; }
  .prospect-question-sequence span { font-size: clamp(25px, 3.2vw, 42px); font-weight: 900; letter-spacing: -.045em; }
  .prospect-question-sequence strong { font-size: clamp(58px, 8.5vw, 110px); font-weight: 950; letter-spacing: -.075em; line-height: .87; }

  .platform-rollcall {
    display: grid;
    grid-template-rows: auto 1fr auto;
    align-items: center;
    justify-items: center;
    padding: 38px 40px;
    box-sizing: border-box;
  }
  .platform-rollcall-lead {
    font-size: clamp(22px, 2.8vw, 36px);
    font-weight: 950;
    letter-spacing: -.045em;
    opacity: 0;
    animation: scan-copy-in 420ms ease forwards;
  }
  .platform-rollcall-stage { position: relative; display: grid; place-items: center; width: 100%; height: 220px; }
  .platform-rollcall-item {
    position: absolute;
    display: flex;
    align-items: center;
    gap: clamp(15px, 3vw, 35px);
    opacity: 0;
    transform: translateY(70px) rotate(4deg) scale(.8);
    animation: platform-name-roll 2300ms cubic-bezier(.18,.84,.22,1) both;
    animation-delay: calc(var(--rollcall-index) * 1550ms + 350ms);
  }
  .platform-rollcall-item img { width: clamp(75px, 10vw, 125px); height: clamp(75px, 10vw, 125px); object-fit: contain; }
  .platform-rollcall-item:nth-child(2) img { width: clamp(88px, 12vw, 145px); height: clamp(88px, 12vw, 145px); }
  .platform-rollcall-item strong { font-size: clamp(55px, 8.5vw, 112px); font-weight: 950; letter-spacing: -.075em; line-height: .85; }
  .platform-rollcall-community {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 11px 18px;
    padding: 12px 20px;
    font-size: clamp(15px, 2vw, 25px);
    font-weight: 900;
    letter-spacing: -.035em;
    opacity: 0;
    transform: translateY(15px);
    animation: community-roll-in 520ms 5550ms cubic-bezier(.18,.84,.22,1) forwards;
  }
  .platform-rollcall-community svg { width: 25px; height: 25px; stroke-width: 1.55; }
  .platform-rollcall-community b { font-size: 29px; }
  .platform-rollcall-community strong { font: inherit; color: #fff; background: #111; padding: 7px 11px; transform: rotate(-1deg); }

  .known-people-sequence {
    display: grid;
    grid-template-columns: minmax(320px, .9fr) minmax(390px, 1.1fr);
    align-items: center;
    gap: clamp(35px, 7vw, 100px);
    padding: 40px clamp(35px, 7vw, 105px);
    box-sizing: border-box;
  }
  .known-people-copy { display: grid; gap: 6px; }
  .known-people-copy span { font-size: clamp(19px, 2.5vw, 33px); font-weight: 900; letter-spacing: -.04em; opacity: 0; animation: scan-copy-in 420ms ease forwards; }
  .known-people-copy strong { max-width: 590px; font-size: clamp(46px, 6.5vw, 85px); font-weight: 950; letter-spacing: -.07em; line-height: .88; opacity: 0; transform: translateY(28px); animation: contact-copy-in 560ms 220ms cubic-bezier(.18,.84,.22,1) forwards; }
  .contact-tile-row { position: relative; height: 250px; }
  .contact-tile {
    position: absolute;
    top: calc(var(--contact-index) * 42px);
    left: calc(var(--contact-index) * 30px);
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    gap: 11px;
    width: min(350px, 70vw);
    padding: 9px 10px;
    background: #fff;
    border-radius: 18px;
    box-shadow: 0 14px 38px rgba(0,0,0,.1);
    box-sizing: border-box;
    opacity: 0;
    transform: translateX(70px) rotate(calc((var(--contact-index) - 1.5) * 1.5deg));
    animation: contact-tile-in 520ms cubic-bezier(.18,.84,.22,1) forwards;
    animation-delay: calc(300ms + var(--contact-index) * 120ms);
  }
  .contact-tile span { font-size: 11px; font-weight: 900; }
  .contact-tile b { padding: 7px 10px; border-radius: 8px; color: #fff; background: #111; font-size: 8px; letter-spacing: .04em; }

  .one-to-one-final {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 42px;
    padding: 40px;
    box-sizing: border-box;
  }
  .one-to-one-equation { display: flex; align-items: center; gap: clamp(24px, 6vw, 78px); }
  .one-to-one-equation > strong { font-size: clamp(45px, 6vw, 78px); opacity: 0; animation: arrow-shoot-in 480ms 520ms cubic-bezier(.18,.84,.22,1) forwards; }
  .one-person,
  .one-message { display: grid; justify-items: center; gap: 10px; opacity: 0; transform: scale(.75); animation: chip-in 500ms cubic-bezier(.18,.84,.22,1) forwards; }
  .one-message { animation-delay: 760ms; }
  .one-person > svg,
  .one-message svg { width: clamp(72px, 9vw, 112px); height: clamp(72px, 9vw, 112px); }
  .one-person > svg { padding: 20px; border: 2px solid #111; border-radius: 50%; box-sizing: border-box; stroke-width: 1.35; }
  .one-message svg { padding: 19px; color: #fff; background: #111; border-radius: 50%; box-sizing: border-box; stroke-width: 1.4; }
  .one-person span,
  .one-message span { font-size: 10px; font-weight: 900; letter-spacing: .08em; }
  .one-to-one-copy { display: grid; justify-items: center; gap: 5px; text-align: center; }
  .one-to-one-copy span { font-size: clamp(15px, 2vw, 25px); font-weight: 900; letter-spacing: -.025em; opacity: 0; animation: scan-copy-in 430ms 1050ms ease forwards; }
  .one-to-one-copy strong { font-size: clamp(55px, 8vw, 105px); font-weight: 950; letter-spacing: -.075em; line-height: .86; opacity: 0; transform: translateY(25px); animation: contact-copy-in 560ms 1220ms cubic-bezier(.18,.84,.22,1) forwards; }

  .intro-integrated {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 18px;
    padding: 42px clamp(28px, 7vw, 105px);
    box-sizing: border-box;
  }

  .intro-integrated .where-word-reveal {
    max-width: 980px;
    font-size: clamp(38px, 4.9vw, 62px);
  }

  .intro-opening-line,
  .intro-opening-question,
  .inline-cold-outreach,
  .inline-community-copy,
  .inline-final-outreach {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }

  .intro-opening-line { gap: 18px; }
  .intro-opening-line .where-word-reveal { max-width: 760px; }
  .intro-opening-question { gap: 12px; }
  .intro-opening-question .where-word-reveal { font-size: clamp(35px, 4.5vw, 58px); }
  .intro-opening-question > strong {
    font-size: clamp(58px, 7vw, 92px);
    font-weight: 950;
    line-height: .75;
    opacity: 0;
    transform: rotate(-9deg) scale(.65);
    animation: intro-question-pop 520ms 3900ms cubic-bezier(.18,.84,.22,1) forwards;
  }

  .inline-profile-stack {
    position: relative;
    display: block;
    width: 154px;
    height: 58px;
    flex: 0 0 154px;
  }

  .inline-profile-stack img {
    position: absolute;
    top: 0;
    left: calc(var(--prospect-index) * 32px);
    width: 54px;
    height: 54px;
    object-fit: cover;
    border: 3px solid #fff;
    border-radius: 50%;
    opacity: 0;
    transform: translateX(18px) rotate(calc((var(--prospect-index) - 1.5) * 4deg));
    animation:
      inline-profile-in 480ms cubic-bezier(.18,.84,.22,1) forwards,
      inline-profile-out 500ms 3000ms cubic-bezier(.55,.05,.68,.53) forwards;
    animation-delay:
      calc(400ms + var(--prospect-index) * 90ms),
      calc(3000ms + var(--prospect-index) * 35ms);
  }

  .intro-cold-statement { gap: 8px; }
  .intro-cold-statement > .where-word-reveal { font-size: clamp(35px, 4.5vw, 60px); }
  .inline-cold-outreach { gap: 17px; }
  .inline-cold-outreach svg {
    width: clamp(48px, 6vw, 76px);
    height: clamp(48px, 6vw, 76px);
    stroke-width: 1.55;
    opacity: 0;
    transform: translateY(12px) rotate(-8deg);
    animation: inline-icon-in 500ms 340ms cubic-bezier(.18,.84,.22,1) forwards;
  }
  .inline-cold-outreach .where-word-reveal {
    width: auto;
    font-size: clamp(46px, 5.8vw, 76px);
  }

  .intro-integrated.intro-platform-focus {
    gap: 24px;
  }
  .intro-platform-focus > .where-word-reveal { font-size: clamp(38px, 4.8vw, 62px); }
  .inline-platforms {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    flex-wrap: wrap;
    gap: clamp(22px, 4vw, 55px);
  }
  .inline-platform {
    display: flex;
    align-items: center;
    gap: 9px;
    opacity: 0;
    transform: translateY(13px);
    animation: where-platform-in 480ms cubic-bezier(.18,.84,.22,1) forwards;
    animation-delay: var(--platform-delay);
  }
  .inline-platform img { width: 37px; height: 37px; object-fit: contain; }
  .inline-platform:nth-child(2) img { width: 45px; height: 45px; }
  .inline-platform strong { font-size: clamp(15px, 1.7vw, 21px); font-weight: 900; letter-spacing: -.035em; }
  .inline-community-copy { gap: 14px; max-width: 900px; margin-top: 6px; }
  .inline-community-copy > svg {
    width: 42px;
    height: 42px;
    flex: 0 0 auto;
    stroke-width: 1.5;
    opacity: 0;
    animation: inline-icon-in 460ms 1050ms cubic-bezier(.18,.84,.22,1) forwards;
  }
  .inline-community-copy .where-word-reveal { width: min(780px, 100%); font-size: clamp(24px, 3vw, 40px); line-height: 1.04; }

  .intro-known-people { gap: 30px; }
  .intro-known-people .where-word-reveal { max-width: 850px; }
  .inline-known-avatars { display: flex; align-items: center; padding-left: 24px; }
  .inline-known-avatars img {
    width: 62px;
    height: 62px;
    margin-left: -24px;
    object-fit: cover;
    border: 4px solid #fff;
    border-radius: 50%;
    opacity: 0;
    transform: translateX(18px) scale(.82);
    animation: known-avatar-in 480ms cubic-bezier(.18,.84,.22,1) forwards;
    animation-delay: var(--known-delay);
  }

  .intro-integrated.intro-final { gap: 12px; }
  .intro-final > .where-word-reveal { max-width: 880px; font-size: clamp(32px, 4.2vw, 55px); }
  .inline-final-outreach { gap: 18px; }
  .inline-final-outreach .where-word-reveal { width: auto; font-size: clamp(50px, 7vw, 90px); }
  .final-dm-pair { position: relative; width: 82px; height: 70px; }
  .final-dm-pair img { width: 62px; height: 62px; border-radius: 50%; object-fit: cover; }
  .final-dm-pair svg {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 27px;
    height: 27px;
    padding: 6px;
    color: #fff;
    background: #111;
    border: 3px solid #fff;
    border-radius: 50%;
    box-sizing: border-box;
    opacity: 0;
    transform: scale(.5);
    animation: inline-icon-in 450ms 350ms cubic-bezier(.18,.84,.22,1) forwards;
  }

  .where-platform-intro {
    position: absolute;
    inset: 0;
    display: grid;
    grid-template-columns: minmax(280px, .9fr) minmax(420px, 1.1fr);
    align-items: center;
    gap: clamp(42px, 7vw, 100px);
    padding: 40px clamp(34px, 7vw, 105px);
    box-sizing: border-box;
  }

  .where-platform-copy h1 {
    max-width: 520px;
    margin: 0;
    font-size: clamp(34px, 4.4vw, 60px);
    font-weight: 950;
    letter-spacing: -.06em;
    line-height: .98;
    animation: where-caption-in 560ms cubic-bezier(.18,.84,.22,1) both;
  }

  .where-platform-copy p {
    max-width: 430px;
    margin: 22px 0 0;
    color: #686868;
    font-size: clamp(12px, 1.35vw, 16px);
    line-height: 1.55;
    animation: where-caption-in 560ms 120ms cubic-bezier(.18,.84,.22,1) both;
  }

  .where-platforms {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    align-items: center;
    gap: 12px;
  }

  .where-platform {
    display: grid;
    justify-items: center;
    gap: 18px;
    opacity: 0;
    transform: translateY(18px);
    animation: where-platform-in 600ms cubic-bezier(.18,.84,.22,1) forwards;
    animation-delay: var(--platform-delay);
  }

  .where-platform div {
    display: grid;
    place-items: center;
    width: 84px;
    height: 84px;
    color: #111;
    font-size: 48px;
  }

  .where-platform div img {
    display: block;
    width: 64px;
    height: 64px;
    object-fit: contain;
  }

  .where-platform.platform-1 div img {
    width: 76px;
    height: 76px;
  }

  .where-platform strong {
    font-size: 13px;
    font-weight: 850;
    letter-spacing: -0.02em;
  }

  .where-walkthrough,
  .bumble-example {
    position: absolute;
    inset: 0;
    display: grid;
    grid-template-columns: minmax(240px, .82fr) minmax(340px, 1.18fr);
    align-items: center;
    gap: clamp(38px, 6vw, 86px);
    padding: 25px clamp(24px, 5vw, 72px);
    box-sizing: border-box;
  }

  .where-walkthrough-copy,
  .bumble-copy {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .where-walkthrough-copy h1,
  .bumble-copy h1 {
    max-width: 470px;
    margin: 0;
    font-size: clamp(30px, 4vw, 54px);
    font-weight: 950;
    letter-spacing: -0.055em;
    line-height: .98;
    text-align: left;
    animation: where-caption-in 480ms cubic-bezier(.18,.84,.22,1) both;
  }

  .bumble-copy p {
    max-width: 320px;
    margin: 18px 0 0;
    color: #666;
    font-size: 14px;
    line-height: 1.45;
    animation: where-caption-in 480ms 110ms cubic-bezier(.18,.84,.22,1) both;
  }

  .where-phone-frame,
  .bumble-chat {
    position: relative;
    justify-self: center;
    width: min(390px, 100%);
    height: 455px;
    overflow: hidden;
    background: #fff;
    border: 1px solid #d8d8d8;
    border-radius: 28px;
    box-shadow: 0 20px 55px rgba(0, 0, 0, .1);
  }

  .instagram-status-bar,
  .bumble-status-bar {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    z-index: 4;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 22px;
    padding: 0 17px;
    font-size: 7px;
    box-sizing: border-box;
    background: #fff;
  }

  .instagram-status-bar span,
  .bumble-status-bar span { font-size: 6px; letter-spacing: 1px; }

  .instagram-bottom-nav {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 4;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    place-items: center;
    height: 38px;
    border-top: 1px solid #ededed;
    background: #fff;
  }

  .instagram-bottom-nav svg { width: 16px; height: 16px; }
  .instagram-bottom-nav img { width: 19px; height: 19px; border-radius: 50%; object-fit: cover; }
  .instagram-home-icon { width: 15px; height: 15px; border: 1.7px solid #111; transform: rotate(45deg); border-radius: 2px; }
  .instagram-create-icon { display: grid; place-items: center; width: 17px; height: 17px; border: 1.5px solid #111; border-radius: 4px; font-size: 12px; line-height: 1; }

  .instagram-screen {
    position: absolute;
    top: 22px;
    right: 0;
    bottom: 38px;
    left: 0;
    overflow: hidden;
    background: #fff;
    animation: instagram-screen-in 400ms cubic-bezier(.18,.84,.22,1) both;
  }

  .instagram-header {
    display: grid;
    grid-template-columns: 35px 1fr 35px;
    align-items: center;
    min-height: 48px;
    padding: 0 14px;
    border-bottom: 1px solid #ececec;
    box-sizing: border-box;
  }

  .instagram-header > span { font-size: 31px; font-weight: 400; line-height: 1; }
  .instagram-header > strong { font-size: 13px; font-weight: 850; text-align: center; }
  .instagram-header > svg { justify-self: end; width: 17px; }
  .instagram-header > i { justify-self: end; font-style: normal; font-size: 12px; letter-spacing: 2px; }

  .instagram-search-field {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 37px;
    margin: 14px;
    padding: 0 12px;
    color: #777;
    font-size: 12px;
    background: #f2f2f2;
    border-radius: 9px;
  }

  .instagram-search-field svg { width: 15px; flex: 0 0 auto; }
  .instagram-query { overflow: hidden; white-space: nowrap; width: 0; animation: instagram-query-in 1300ms 350ms steps(13, end) forwards; }

  .instagram-search-prompt {
    display: grid;
    justify-items: center;
    gap: 12px;
    margin-top: 105px;
    color: #a3a3a3;
  }

  .instagram-search-prompt img { width: 34px; height: 34px; object-fit: contain; }
  .instagram-search-prompt strong { font-size: 12px; font-weight: 700; }

  .instagram-results,
  .instagram-people { padding: 3px 14px 0; }

  .instagram-result,
  .instagram-person {
    display: grid;
    grid-template-columns: 43px 1fr auto;
    align-items: center;
    gap: 11px;
    min-height: 61px;
    opacity: .45;
  }

  .instagram-result.is-selected,
  .instagram-person.is-selected { opacity: 1; }

  .instagram-result > span,
  .instagram-person > span,
  .instagram-person > img {
    display: grid;
    place-items: center;
    width: 40px;
    height: 40px;
    overflow: hidden;
    color: #111;
    font-size: 10px;
    font-weight: 900;
    background: #efefef;
    border-radius: 50%;
    object-fit: cover;
  }

  .instagram-result.is-selected > span { border: 1.5px solid #c12da9; background: #fff; }
  .instagram-result div,
  .instagram-person div { display: grid; gap: 3px; }
  .instagram-result strong,
  .instagram-person strong { font-size: 11px; }
  .instagram-result small,
  .instagram-person small { color: #777; font-size: 9px; }
  .instagram-person button { padding: 6px 13px; border: 0; border-radius: 7px; color: #fff; font-size: 9px; font-weight: 800; background: #0095f6; }

  .instagram-community-summary,
  .instagram-profile-summary {
    display: grid;
    grid-template-columns: 92px repeat(3, 1fr);
    align-items: center;
    padding: 18px 17px 11px;
  }

  .instagram-community-summary > div:not(.community-avatar),
  .instagram-profile-summary > div { display: grid; justify-items: center; gap: 2px; }
  .instagram-community-summary strong,
  .instagram-profile-summary strong { font-size: 13px; }
  .instagram-community-summary small,
  .instagram-profile-summary small { color: #666; font-size: 8px; }

  .community-avatar,
  .instagram-profile-summary img {
    display: grid;
    place-items: center;
    width: 72px;
    height: 72px;
    color: #fff;
    font-size: 18px;
    font-weight: 950;
    background: #111;
    border-radius: 50%;
    object-fit: cover;
  }

  .instagram-community-bio,
  .instagram-profile-bio { display: grid; gap: 3px; padding: 0 17px 10px; font-size: 10px; }
  .instagram-community-bio strong,
  .instagram-profile-bio strong { font-size: 11px; }
  .instagram-profile-bio strong small { color: #777; font-size: 9px; font-weight: 500; }

  .instagram-followers-button,
  .instagram-message-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    width: calc(100% - 34px);
    height: 32px;
    margin: 0 17px 12px;
    border: 0;
    border-radius: 7px;
    color: #111;
    font-size: 10px;
    font-weight: 850;
    background: #efefef;
  }

  .instagram-followers-button svg,
  .instagram-message-button svg { width: 13px; }

  .instagram-grid-tab { display: grid; place-items: center; height: 29px; border-top: 1px solid #ececec; color: #333; }
  .instagram-grid-tab svg { width: 15px; }

  .instagram-photo-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2px;
  }

  .instagram-photo-grid img { width: 100%; aspect-ratio: 1; object-fit: cover; }
  .instagram-photo-grid.is-scrolling { animation: instagram-grid-scroll 2400ms 550ms cubic-bezier(.25,.65,.32,1) both; }

  .instagram-dm-person { display: grid; justify-items: center; gap: 3px; padding: 20px 0 10px; }
  .instagram-dm-person img { width: 55px; height: 55px; border-radius: 50%; object-fit: cover; }
  .instagram-dm-person strong { margin-top: 5px; font-size: 11px; }
  .instagram-dm-person small { color: #777; font-size: 8px; }
  .instagram-dm-body { display: flex; align-items: flex-end; justify-content: flex-end; height: 219px; padding: 12px 14px; box-sizing: border-box; }

  .instagram-sent-bubble {
    max-width: 245px;
    padding: 10px 12px;
    color: #fff;
    font-size: 9px;
    line-height: 1.4;
    background: #3797f0;
    border-radius: 16px 16px 4px 16px;
    animation: instagram-message-in 420ms cubic-bezier(.18,.84,.22,1) both;
  }

  .instagram-composer {
    position: absolute;
    right: 13px;
    bottom: 12px;
    left: 13px;
    display: grid;
    grid-template-columns: 1fr 28px;
    align-items: center;
    min-height: 37px;
    padding: 5px 5px 5px 12px;
    border: 1px solid #d8d8d8;
    border-radius: 20px;
    box-sizing: border-box;
  }

  .instagram-composer span { max-height: 31px; overflow: hidden; color: #555; font-size: 8px; line-height: 1.3; }
  .instagram-composer.is-sent span { color: #999; font-size: 10px; }
  .instagram-composer button { display: grid; place-items: center; width: 27px; height: 27px; border: 0; border-radius: 50%; color: #fff; background: #0095f6; }
  .instagram-composer button svg { width: 12px; }

  .bumble-chat { height: 455px; background: #f8f8f8; }
  .bumble-status-bar { background: #ffc629; }
  .bumble-chat > header {
    position: absolute;
    top: 22px;
    right: 0;
    left: 0;
    display: grid;
    grid-template-columns: 32px 1fr 32px;
    align-items: center;
    min-height: 76px;
    padding: 0 14px;
    background: #ffc629;
  }

  .bumble-chat > header > span { font-size: 30px; line-height: 1; }
  .bumble-chat > header > div { display: grid; justify-items: center; gap: 2px; }
  .bumble-chat > header b { display: flex; align-items: center; gap: 4px; margin-bottom: 3px; font-size: 8px; font-weight: 850; }
  .bumble-chat > header b img { width: 15px; height: 15px; object-fit: contain; }
  .bumble-chat > header strong { font-size: 12px; }
  .bumble-chat > header small { font-size: 8px; opacity: .65; }
  .bumble-chat > header i { justify-self: end; font-style: normal; font-size: 11px; letter-spacing: 2px; }

  .bumble-chat-body { min-height: 305px; padding: 112px 14px 55px; box-sizing: border-box; }
  .bumble-day { margin-bottom: 13px; color: #999; font-size: 7px; font-weight: 900; letter-spacing: .1em; text-align: center; }

  .bumble-message {
    display: grid;
    grid-template-columns: 31px 1fr;
    align-items: start;
    gap: 9px;
    margin-bottom: 13px;
  }

  .bumble-message > span { display: grid; place-items: center; width: 29px; height: 29px; border-radius: 50%; color: #555; font-size: 7px; font-weight: 900; background: #efefef; }
  .bumble-message > div { display: grid; justify-items: start; gap: 4px; }
  .bumble-message strong { font-size: 8px; }
  .bumble-message p { max-width: 245px; margin: 0; padding: 8px 10px; font-size: 9px; line-height: 1.35; background: #f2f2f2; border-radius: 4px 12px 12px 12px; }
  .bumble-message.mass-message { animation: bumble-message-in 440ms cubic-bezier(.18,.84,.22,1) both; }
  .bumble-message.mass-message > span { color: #111; background: #ffc629; }
  .bumble-message.mass-message p { background: #fff3c6; }

  .bumble-chat > footer {
    position: absolute;
    right: 12px;
    bottom: 10px;
    left: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 35px;
    padding: 0 11px;
    color: #999;
    font-size: 9px;
    border: 1px solid #ddd;
    border-radius: 18px;
  }
  .bumble-chat > footer svg { width: 13px; color: #111; }

  .bumble-x-overlay {
    position: absolute;
    inset: 0;
    display: grid;
    place-items: center;
    background: rgba(255, 255, 255, .78);
    backdrop-filter: blur(3px);
    animation: bumble-overlay-in 350ms ease both;
  }

  .bumble-x-overlay div {
    display: grid;
    place-items: center;
    width: 88px;
    height: 88px;
    color: #fff;
    background: #111;
    border-radius: 50%;
    transform: rotate(-6deg);
  }
  .bumble-x-overlay svg { width: 47px; height: 47px; stroke-width: 2; }

  .real-app-lesson {
    position: absolute;
    inset: 0;
    display: grid;
    grid-template-columns: minmax(280px, .96fr) minmax(330px, 1.04fr);
    align-items: center;
    gap: clamp(42px, 7vw, 105px);
    padding: 24px clamp(34px, 7vw, 105px);
    box-sizing: border-box;
  }
  .real-app-copy { display: grid; align-content: center; gap: 17px; }
  .real-app-copy h1 {
    max-width: 510px;
    margin: 0;
    font-size: clamp(34px, 4.1vw, 53px);
    font-weight: 820;
    letter-spacing: -.045em;
    line-height: 1;
    animation: real-copy-in 520ms cubic-bezier(.18,.84,.22,1) both;
  }
  .real-app-copy h1.real-copy-word-reveal {
    animation: none;
  }
  .real-copy-word-reveal > span {
    display: inline-block;
    opacity: 0;
    transform: translateY(.34em);
    animation: real-copy-word-in 390ms
      var(--real-copy-word-delay)
      cubic-bezier(.18,.84,.22,1) forwards;
  }
  .real-app-copy p {
    max-width: 410px;
    margin: 0;
    color: #656565;
    font-size: clamp(12px, 1.35vw, 16px);
    line-height: 1.5;
    animation: real-copy-in 520ms 100ms cubic-bezier(.18,.84,.22,1) both;
  }

  .instagram-kinetic-scene .where-word-reveal {
    max-width: 980px;
  }

  .instagram-search-statement {
    gap: 8px;
  }

  .instagram-search-statement > .where-word-reveal {
    font-size: clamp(35px, 4.5vw, 60px);
  }

  .inline-relevant-communities {
    max-width: 1120px;
  }

  .instagram-category-scene {
    position: absolute;
    inset: 0;
    display: grid;
    grid-template-columns: minmax(0, 1fr) 0;
    align-items: center;
    gap: 0;
    padding: 32px clamp(34px, 7vw, 105px);
    box-sizing: border-box;
    animation: instagram-category-scene-in 650ms
      cubic-bezier(.18,.84,.22,1) both;
    transition:
      grid-template-columns 780ms cubic-bezier(.18,.84,.22,1),
      gap 780ms cubic-bezier(.18,.84,.22,1);
  }

  .instagram-category-scene.has-instagram-ui {
    grid-template-columns: minmax(280px, .96fr) minmax(300px, 1.04fr);
    gap: clamp(42px, 7vw, 105px);
  }

  .instagram-category-copy-wrap {
    display: grid;
    place-items: center;
    min-width: 0;
    transition: justify-items 780ms cubic-bezier(.18,.84,.22,1);
  }

  .has-instagram-ui .instagram-category-copy-wrap {
    justify-items: start;
    animation: instagram-category-copy-left 620ms
      cubic-bezier(.18,.84,.22,1) both;
  }

  .instagram-category-copy {
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: .22em;
    width: min(980px, 100%);
    font-size: var(--lesson-hero-size);
    font-weight: var(--lesson-hero-weight);
    letter-spacing: var(--lesson-hero-tracking);
    line-height: 1;
    transition: width 780ms cubic-bezier(.18,.84,.22,1);
  }

  .has-instagram-ui .instagram-category-copy {
    width: min(510px, 100%);
    justify-content: flex-start;
    flex-wrap: wrap;
    font-size: clamp(34px, 4vw, 52px);
  }

  .has-instagram-ui .instagram-category-cue {
    font-size: clamp(24px, 2.55vw, 34px);
  }

  .has-instagram-ui .instagram-category-flip {
    width: 100%;
    flex-basis: 100%;
  }

  .instagram-category-cue {
    display: block;
    flex: 0 0 auto;
    opacity: 0;
    animation: instagram-category-phrase-in 420ms 480ms
      cubic-bezier(.18,.84,.22,1) forwards;
  }

  .instagram-category-flip {
    position: relative;
    display: inline-block;
    width: min(680px, calc(100vw - 260px));
    height: 1.18em;
    overflow: hidden;
    vertical-align: bottom;
    transition: width 780ms cubic-bezier(.18,.84,.22,1);
  }

  .instagram-category-flip > strong {
    position: absolute;
    inset: 0 auto auto 0;
    display: block;
    font: inherit;
    font-family: 'Ugly Handwriting', cursive;
    font-size: 1.12em;
    font-weight: 400;
    letter-spacing: -.012em;
    line-height: .92;
    white-space: nowrap;
    opacity: 0;
    transform: translateY(.42em);
    animation: instagram-category-flip 930ms
      var(--category-delay)
      cubic-bezier(.18,.84,.22,1) both;
  }

  .instagram-category-flip > strong.is-last {
    animation-name: instagram-category-flip-last;
  }

  .has-instagram-ui .instagram-category-flip > strong.is-long {
    font-size: .74em;
  }

  .has-instagram-ui .instagram-category-flip > strong.is-medium {
    font-size: .86em;
  }

  .instagram-category-ui {
    opacity: 0;
    transform: translateX(26px) scale(.985);
    animation: real-ui-in 620ms 260ms
      cubic-bezier(.18,.84,.22,1) forwards;
  }

  .instagram-real-ui,
  .bff-real-ui {
    position: relative;
    justify-self: center;
    width: min(300px, 100%);
    height: 440px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 22px 65px rgba(0,0,0,.11);
    animation: real-ui-in 620ms cubic-bezier(.18,.84,.22,1) both;
  }

  .bff-demo-wrap {
    position: relative;
    justify-self: center;
    width: min(250px, 100%);
    height: 440px;
  }
  .bff-lesson .bff-demo-wrap { opacity: 0; transform: translateX(26px); animation: bff-ui-after-copy 560ms 420ms cubic-bezier(.18,.84,.22,1) forwards; }

  .bff-demo-wrap .bff-real-ui {
    width: 100%;
    height: 100%;
  }

  .bff-static-note {
    position: absolute;
    top: 180px;
    right: -154px;
    z-index: 12;
    width: 124px;
    color: #e1261c;
    font-family: 'Ugly Handwriting', cursive;
    pointer-events: none;
    transform: rotate(3deg);
  }

  .bff-static-note strong {
    display: block;
    width: 0;
    overflow: hidden;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: .01em;
    line-height: .95;
    white-space: nowrap;
    animation: bff-note-write 900ms 2720ms steps(13, end) forwards;
  }

  .bff-static-note svg {
    display: block;
    width: 102px;
    height: 74px;
    margin: 1px 0 0 -7px;
    overflow: visible;
    opacity: 0;
    animation: bff-note-arrow-in 220ms 3620ms ease forwards;
  }

  .bff-static-note path {
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
    vector-effect: non-scaling-stroke;
  }
  .ig-screen { position: absolute; inset: 0; overflow: hidden; color: #111; background: #fff; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; }
  .ig-top-bar { display: grid; grid-template-columns: 37px 1fr 37px; align-items: center; height: 48px; padding: 0 12px; border-bottom: 1px solid #efefef; box-sizing: border-box; }
  .ig-top-bar button { border: 0; padding: 0; background: transparent; font-size: 29px; line-height: 1; text-align: left; }
  .ig-top-bar strong { font-size: 13px; font-weight: 750; text-align: center; }
  .ig-top-bar > span { font-size: 11px; letter-spacing: 2px; text-align: right; }
  .ig-search-header { display: grid; grid-template-columns: 33px 1fr; align-items: center; gap: 6px; padding: 10px 12px 7px; }
  .ig-search-header > button { border: 0; background: transparent; padding: 0; font-size: 28px; text-align: left; }
  .ig-search-header > div { display: grid; grid-template-columns: 19px 1fr 17px; align-items: center; gap: 7px; height: 38px; padding: 0 11px; background: #efefef; border-radius: 10px; box-sizing: border-box; }
  .ig-search-header svg { width: 16px; color: #777; }
  .ig-search-header span { font-size: 12px; }
  .ig-search-placeholder { color: #777; }
  .ig-typed-query { display: inline-block; width: 0; overflow: hidden; white-space: nowrap; animation: ig-query-type 1050ms 280ms steps(13,end) forwards; }
  .ig-search-header b { color: #777; font-size: 14px; font-weight: 500; }
  .ig-search-tabs { display: flex; gap: 21px; padding: 9px 17px 12px; border-bottom: 1px solid #efefef; color: #777; font-size: 10px; white-space: nowrap; }
  .ig-search-tabs strong { color: #111; }
  .ig-results-window {
    height: 336px;
    overflow: hidden;
    opacity: 0;
    animation: ig-results-in 260ms 1420ms ease forwards;
  }
  .ig-account-results { padding: 4px 13px; }
  .ig-account-results.is-scrolling { animation: ig-results-scroll 4600ms 1900ms cubic-bezier(.22,.68,.3,1) forwards; }
  .ig-account-results > div { position: relative; display: grid; grid-template-columns: 49px 1fr; align-items: center; gap: 11px; min-height: 65px; opacity: .52; }
  .ig-account-results > div.is-target { opacity: 1; }
  .ig-account-results > div.is-target.is-opening-target {
    transform-origin: center;
    animation: ig-target-open 420ms 5150ms
      cubic-bezier(.18,.84,.22,1) both;
  }
  .ig-account-results > div.is-target::after { content: ''; position: absolute; inset: 4px -5px; z-index: -1; background: #f7f7f7; border-radius: 10px; }
  .ig-account-results i { display: grid; place-items: center; width: 45px; height: 45px; border-radius: 50%; background: #f0f0f0; font-size: 10px; font-style: normal; font-weight: 800; }
  .ig-account-results .is-target i { border: 2px solid #d42ba4; background: #fff; box-sizing: border-box; }
  .ig-account-results span { display: grid; gap: 4px; }
  .ig-account-results strong { font-size: 11px; }
  .ig-account-results strong b { display: inline-grid; place-items: center; width: 11px; height: 11px; margin-left: 2px; border-radius: 50%; color: #fff; background: #0095f6; font-size: 7px; }
  .ig-account-results small { color: #777; font-size: 9px; }
  .ig-search-empty { display: grid; justify-items: center; gap: 7px; margin-top: 108px; color: #9a9a9a; }
  .ig-search-empty svg { width: 30px; height: 30px; stroke-width: 1.35; }
  .ig-search-empty strong { color: #777; font-size: 11px; }
  .ig-search-empty span { font-size: 9px; }

  .ig-search-community-overlay {
    position: absolute;
    inset: 0;
    z-index: 6;
    overflow: hidden;
    background: #fff;
    opacity: 0;
    transform: translateX(20px);
    animation: ig-search-community-open 320ms 5680ms
      cubic-bezier(.18,.84,.22,1) forwards;
  }

  .ig-community-viewport { position: absolute; top: 48px; right: 0; bottom: 0; left: 0; overflow: hidden; background: #fff; }
  .ig-community-scroll { transform: translateY(0); }
  .ig-profile-summary { display: grid; grid-template-columns: 100px repeat(3, 1fr); align-items: center; padding: 17px 16px 10px; }
  .ig-profile-summary > div:not(.ig-community-avatar) { display: grid; justify-items: center; gap: 2px; }
  .ig-profile-summary > div strong { font-size: 13px; }
  .ig-profile-summary > div small { font-size: 8px; }
  .ig-community-avatar,
  .ig-avatar { display: grid; place-items: center; width: 77px; height: 77px; border-radius: 50%; object-fit: cover; }
  .ig-community-avatar { display: block; background: #f1f1f1; }
  .ig-profile-bio { display: grid; gap: 3px; padding: 0 17px 10px; font-size: 9px; }
  .ig-profile-bio > strong { font-size: 11px; }
  .ig-profile-bio > strong small { color: #777; font-size: 9px; font-weight: 500; }
  .ig-profile-bio > span { color: #777; }
  .ig-profile-bio p { margin: 0; line-height: 1.35; }
  .ig-profile-actions { display: grid; grid-template-columns: 1fr 1fr 34px; gap: 6px; padding: 0 16px 11px; }
  .ig-profile-actions button { height: 29px; border: 0; border-radius: 7px; color: #111; background: #efefef; font-size: 9px; font-weight: 750; }
  .ig-profile-actions button:first-child { color: #fff; background: #0095f6; }
  .ig-profile-actions button.is-message { color: #111; background: #efefef; }
  .ig-followed-by { display: grid; grid-template-columns: 22px 22px 1fr; align-items: center; padding: 1px 17px 11px; }
  .ig-followed-by > span { display: grid; place-items: center; width: 23px; height: 23px; margin-right: -5px; border: 2px solid #fff; border-radius: 50%; background: #e8e8e8; font-size: 6px; font-weight: 800; }
  .ig-followed-by p { margin: 0 0 0 8px; font-size: 8px; }
  .ig-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 2px; border-top: 1px solid #eee; }
  .ig-grid img { width: 100%; aspect-ratio: 1; object-fit: cover; }
  .ig-list-search { display: flex; align-items: center; gap: 7px; height: 33px; margin: 11px 14px 5px; padding: 0 10px; border-radius: 9px; color: #777; background: #efefef; font-size: 10px; }
  .ig-list-search svg { width: 14px; }
  .ig-followers-list { padding: 2px 13px; }
  .ig-followers-window { height: 337px; overflow: hidden; }
  .ig-followers-list.is-scrolling { animation: ig-followers-scroll 2200ms 250ms cubic-bezier(.22,.68,.3,1) forwards; }
  .ig-followers-list > div { position: relative; display: grid; grid-template-columns: 47px 1fr auto; align-items: center; gap: 10px; min-height: 65px; opacity: .45; }
  .ig-followers-list > div.is-target { opacity: 1; }
  .ig-followers-list > div.is-target::after { content: ''; position: absolute; inset: 4px -5px; z-index: -1; background: #f7f7f7; border-radius: 10px; }
  .ig-followers-list img { width: 43px; height: 43px; border-radius: 50%; object-fit: cover; }
  .ig-followers-list span { display: grid; gap: 3px; }
  .ig-followers-list strong { font-size: 10px; }
  .ig-followers-list small { color: #777; font-size: 9px; }
  .ig-followers-list button { padding: 7px 15px; border: 0; border-radius: 7px; color: #fff; background: #0095f6; font-size: 9px; font-weight: 750; }
  .ig-followers-screen.is-selecting-profile .ig-followers-list > div {
    opacity: .24;
  }
  .ig-followers-screen.is-selecting-profile .ig-followers-list > div.is-being-selected {
    opacity: 1;
    animation: ig-profile-row-select 720ms 220ms
      cubic-bezier(.18,.84,.22,1) both;
  }
  .ig-followers-screen.is-selecting-profile .ig-followers-list > div.is-being-selected button {
    animation: ig-profile-button-press 720ms 560ms
      cubic-bezier(.18,.84,.22,1) both;
  }
  .ig-selected-profile-overlay {
    position: absolute;
    inset: 0;
    z-index: 5;
    overflow: hidden;
    background: #fff;
    opacity: 0;
    transform: translateX(24px);
    animation: ig-selected-profile-open 560ms 1450ms
      cubic-bezier(.18,.84,.22,1) forwards;
  }
  .ig-profile-actions button.is-message { animation: ig-message-button-focus 900ms 450ms ease-in-out 2; }

  .ig-dm-header { display: grid; grid-template-columns: 30px 38px 1fr 27px; align-items: center; gap: 7px; height: 54px; padding: 0 12px; border-bottom: 1px solid #eee; }
  .ig-dm-header button { border: 0; background: transparent; padding: 0; font-size: 28px; }
  .ig-dm-header img { width: 34px; height: 34px; border-radius: 50%; object-fit: cover; }
  .ig-dm-header span { display: grid; gap: 2px; }
  .ig-dm-header strong { font-size: 11px; }
  .ig-dm-header small { color: #777; font-size: 8px; }
  .ig-dm-header b { font-size: 16px; font-weight: 500; }
  .ig-dm-profile { display: grid; justify-items: center; gap: 3px; padding: 18px 0 8px; }
  .ig-dm-profile img { width: 61px; height: 61px; border-radius: 50%; object-fit: cover; }
  .ig-dm-profile strong { margin-top: 4px; font-size: 11px; }
  .ig-dm-profile small { color: #777; font-size: 8px; }
  .ig-dm-profile button { margin-top: 4px; padding: 7px 12px; border: 0; border-radius: 7px; font-size: 8px; font-weight: 750; }
  .ig-dm-thread { display: flex; align-items: flex-end; justify-content: flex-end; height: 191px; padding: 12px 14px; box-sizing: border-box; }
  .ig-outgoing-message { max-width: 270px; padding: 10px 12px; border-radius: 16px 16px 4px 16px; color: #fff; background: #3797f0; font-size: 9px; line-height: 1.4; animation: ig-message-send 420ms cubic-bezier(.18,.84,.22,1) both; }
  .ig-message-composer { position: absolute; right: 12px; bottom: 12px; left: 12px; display: grid; grid-template-columns: 1fr 29px; align-items: center; min-height: 38px; padding: 4px 4px 4px 12px; border: 1px solid #ddd; border-radius: 20px; box-sizing: border-box; }
  .ig-message-composer span { max-height: 29px; overflow: hidden; color: #666; font-size: 8px; line-height: 1.3; }
  .ig-message-composer button { display: grid; place-items: center; width: 29px; height: 29px; border: 0; border-radius: 50%; color: #fff; background: #0095f6; }
  .ig-message-composer svg { width: 13px; }

  .bff-match-screen {
    position: absolute;
    inset: 0;
    overflow: hidden;
    color: #191919;
    background: #fdfbfc;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  }

  .bff-discover-tabs {
    display: flex;
    align-items: center;
    gap: 7px;
    height: 58px;
    padding: 8px 7px 6px;
    box-sizing: border-box;
    overflow: hidden;
    white-space: nowrap;
  }

  .bff-discover-tabs > strong,
  .bff-round-tab {
    display: grid;
    place-items: center;
    height: 41px;
    flex: 0 0 auto;
    background: #fff18b;
  }

  .bff-discover-tabs > strong {
    min-width: 103px;
    padding: 0 13px;
    box-sizing: border-box;
    border-radius: 22px;
    font-size: 23px;
    font-weight: 850;
    letter-spacing: -.045em;
  }

  .bff-round-tab {
    width: 41px;
    border-radius: 50%;
  }

  .bff-round-tab svg {
    width: 23px;
    height: 23px;
    stroke: currentColor;
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .bff-discover-tabs > b {
    margin-left: 2px;
    color: #bebcc0;
    font-size: 22px;
    font-weight: 800;
    letter-spacing: -.04em;
  }

  .bff-discover-feed {
    display: grid;
    gap: 10px;
    animation: bff-discover-feed-scroll 5600ms 420ms
      cubic-bezier(.2,.72,.22,1) forwards;
  }

  .bff-discover-card {
    position: relative;
    height: 374px;
    margin: 0 6px;
    overflow: hidden;
    border-radius: 19px;
    background: #dedede;
    animation: bff-profile-card-in 560ms cubic-bezier(.18,.84,.22,1) both;
  }

  .bff-discover-card > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .bff-discover-card::after {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      180deg,
      rgba(0,0,0,.32) 0%,
      transparent 27%,
      transparent 56%,
      rgba(0,0,0,.72) 100%
    );
    content: '';
  }

  .bff-discover-identity {
    position: absolute;
    z-index: 2;
    top: 18px;
    left: 15px;
    display: grid;
    justify-items: start;
    gap: 2px;
    color: #fff;
  }

  .bff-discover-identity > strong {
    font-size: 25px;
    font-weight: 850;
    letter-spacing: -.045em;
    text-shadow: 0 1px 3px rgba(0,0,0,.32);
  }

  .bff-discover-identity > span {
    font-size: 10px;
    text-shadow: 0 1px 3px rgba(0,0,0,.32);
  }

  .bff-discover-identity > small {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-top: 9px;
    padding: 7px 10px;
    color: #171717;
    background: #fff18b;
    border-radius: 10px;
    font-size: 10px;
  }

  .bff-discover-identity > small svg {
    width: 15px;
    height: 15px;
    stroke: currentColor;
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .bff-discover-details {
    position: absolute;
    z-index: 2;
    right: 13px;
    bottom: 13px;
    left: 13px;
    color: #fff;
  }

  .bff-discover-details p {
    max-width: 220px;
    margin: 0 0 11px;
    font-size: 10px;
    line-height: 1.38;
  }

  .bff-discover-details > button {
    position: absolute;
    right: 0;
    bottom: 36px;
    display: grid;
    place-items: center;
    width: 58px;
    height: 58px;
    padding: 0;
    color: #171717;
    background: #fff18b;
    border: 0;
    border-radius: 50%;
    animation: bff-wave-button-in 520ms 450ms
      cubic-bezier(.18,.84,.22,1) both;
  }

  .bff-discover-details > button svg {
    width: 33px;
    height: 33px;
    stroke: currentColor;
    stroke-width: 1.7;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .bff-interest-row {
    display: flex;
    align-items: center;
    gap: 5px;
    width: calc(100% + 7px);
    overflow: hidden;
  }

  .bff-interest-row span {
    flex: 0 0 auto;
    padding: 6px 9px;
    color: #fff;
    background: rgba(18,18,18,.9);
    border-radius: 999px;
    font-size: 8px;
  }

  .bff-chat-header {
    display: grid;
    grid-template-columns: 35px 1fr 35px;
    align-items: center;
    height: 57px;
    padding: 0 9px;
    border-bottom: 1px solid #e4e1e4;
    box-sizing: border-box;
  }

  .bff-chat-header > button {
    padding: 0;
    border: 0;
    background: transparent;
    font-size: 31px;
    font-weight: 300;
    line-height: 1;
  }

  .bff-chat-header > span {
    display: grid;
    justify-items: center;
    gap: 1px;
  }

  .bff-chat-header strong { font-size: 13px; }
  .bff-chat-header small { color: #777; font-size: 8px; font-weight: 400; }
  .bff-chat-header > b { font-size: 11px; letter-spacing: 2px; }

  .bff-chat-history {
    display: grid;
    justify-items: center;
    gap: 9px;
    padding-top: 148px;
    color: #858185;
    text-align: center;
  }

  .bff-chat-history > img {
    width: 76px;
    height: 76px;
    object-fit: cover;
    border-radius: 12px;
  }

  .bff-chat-history > p {
    max-width: 230px;
    margin: 0;
    font-size: 10px;
    line-height: 1.35;
  }

  .bff-chat-history > div {
    display: flex;
    gap: 7px;
  }

  .bff-chat-history > div span {
    padding: 7px 10px;
    color: #343134;
    background: #fbf8fa;
    border-radius: 999px;
    font-size: 8px;
  }

  .bff-sent-message {
    position: absolute;
    right: 12px;
    bottom: 55px;
    max-width: 235px;
    padding: 9px 11px;
    color: #171717;
    background: #fff18b;
    border-radius: 15px 15px 4px 15px;
    font-size: 8px;
    line-height: 1.36;
    opacity: 0;
    transform: translateY(10px);
    animation: bff-chat-message-in 420ms 1420ms
      cubic-bezier(.18,.84,.22,1) forwards;
  }

  .bff-chat-composer {
    position: absolute;
    right: 8px;
    bottom: 9px;
    left: 8px;
    display: grid;
    grid-template-columns: 27px 1fr 21px 25px 20px 15px;
    align-items: center;
    gap: 6px;
    color: #159bf2;
  }

  .bff-chat-composer > button {
    display: grid;
    place-items: center;
    width: 25px;
    height: 25px;
    padding: 0;
    color: #fff;
    background: #159bf2;
    border: 0;
    border-radius: 50%;
    font-size: 20px;
    font-weight: 300;
  }

  .bff-chat-composer > span {
    min-width: 0;
    padding: 8px 10px;
    color: #8c888c;
    background: #fbf9fa;
    border-radius: 999px;
    font-size: 9px;
  }

  .bff-chat-composer > b { font-size: 17px; }
  .bff-chat-composer > small {
    padding: 4px 3px;
    color: #fff;
    background: #159bf2;
    border-radius: 4px;
    font-size: 7px;
    font-weight: 850;
  }
  .bff-chat-composer > i { font-size: 18px; font-style: normal; }
  .bff-chat-composer > em { font-size: 15px; font-style: normal; }

  .bff-connected-overlay {
    position: absolute;
    inset: 0;
    z-index: 8;
    display: grid;
    align-content: center;
    justify-items: center;
    gap: 24px;
    padding: 32px 22px;
    box-sizing: border-box;
    background: #fdfbfc;
    animation: bff-connected-away 360ms 1120ms ease forwards;
  }

  .bff-connected-overlay > strong {
    font-size: 26px;
    font-weight: 730;
    letter-spacing: -.035em;
    line-height: 1.08;
    text-align: center;
  }

  .bff-connected-overlay > div {
    position: relative;
    width: 245px;
    height: 285px;
  }

  .bff-connected-overlay img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 18px;
  }

  .bff-connected-overlay span {
    position: absolute;
    top: -15px;
    left: -14px;
    display: grid;
    place-items: center;
    width: 63px;
    height: 63px;
    background: #fff18b;
    border-radius: 50%;
  }

  .bff-connected-overlay svg {
    width: 36px;
    height: 36px;
    stroke: currentColor;
    stroke-width: 1.7;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .bff-kinetic-opening { position: absolute; inset: 0; display: grid; place-items: center; padding: 42px; box-sizing: border-box; }
  .bff-kinetic-opening .where-word-reveal {
    max-width: 980px;
    font-size: var(--lesson-hero-size);
  }
  .bff-invitation-sentence { display: flex; align-items: center; justify-content: center; flex-wrap: wrap; gap: 12px 17px; max-width: 1050px; font-size: var(--lesson-hero-size); font-weight: var(--lesson-hero-weight); letter-spacing: var(--lesson-hero-tracking); line-height: 1; text-align: center; }
  .bff-invitation-icon { position: relative; display: grid; place-items: center; width: .88em; height: .72em; border: 2px solid #111; border-radius: .2em; opacity: 0; transform: translateY(.22em) rotate(-4deg) scale(.86); animation: bff-invitation-icon-in 480ms 300ms cubic-bezier(.18,.84,.22,1) forwards, bff-invitation-icon-send 680ms 3250ms cubic-bezier(.55,.02,.8,.38) forwards; }
  .bff-invitation-icon svg { width: .48em; height: .48em; stroke-width: 1.8; }
  .bff-invitation-icon::before,
  .bff-invitation-icon::after { content: ''; position: absolute; top: 34%; right: calc(100% + 9px); width: .55em; height: 2px; border-radius: 2px; background: #111; opacity: 0; transform: scaleX(.35); transform-origin: right center; animation: bff-invitation-streak 520ms 3230ms ease-out forwards; }
  .bff-invitation-icon::after { top: 66%; right: calc(100% + 2px); width: .38em; animation-delay: 3310ms; }
  .bff-feel-intentional {
    display: inline-flex;
    align-items: baseline;
    gap: .18em;
    white-space: nowrap;
  }
  .bff-individual-message {
    display: flex;
    align-items: baseline;
    justify-content: center;
    flex-wrap: wrap;
    gap: .2em;
    max-width: 980px;
    font-size: var(--lesson-hero-size);
    font-weight: var(--lesson-hero-weight);
    letter-spacing: var(--lesson-hero-tracking);
    line-height: 1;
    text-align: center;
  }
  .bff-direct-warning .where-word-reveal { max-width: 850px; }
  .bff-cycle-warning { display: flex; align-items: center; justify-content: center; flex-wrap: wrap; gap: 13px 18px; max-width: 1100px; font-size: var(--lesson-hero-size); font-weight: var(--lesson-hero-weight); letter-spacing: var(--lesson-hero-tracking); line-height: 1; text-align: center; }
  .bff-cycle-destinations { position: relative; display: grid; place-items: center; width: min(680px, calc(100vw - 48px)); height: 1.02em; padding: .08em .22em .1em .12em; overflow: hidden; color: #fff; background: #111; border-radius: 999px; box-sizing: border-box; opacity: 0; transform: translateY(.16em) rotate(-1deg) scale(.9); animation: bff-cycle-shell-in 500ms 360ms cubic-bezier(.18,.84,.22,1) forwards; }
  .bff-cycle-destinations strong { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; gap: .16em; font-size: clamp(.64em, 4.8vw, .82em); white-space: nowrap; opacity: 0; transform: translateY(.48em); animation: bff-destination-cycle 800ms 160ms cubic-bezier(.18,.84,.22,1) both; }
  .bff-cycle-destinations strong:nth-child(2) { animation-delay: 960ms; }
  .bff-cycle-destinations strong:nth-child(3) {
    animation: bff-destination-last 360ms 1760ms
      cubic-bezier(.18,.84,.22,1) forwards;
  }
  .bff-cycle-icon { display: grid; place-items: center; width: .7em; height: .7em; flex: 0 0 .7em; color: #111; background: #fff; border-radius: 50%; }
  .bff-cycle-icon svg { width: 50%; height: 50%; stroke-width: 1.8; }
  .bff-cycle-icon img { width: 72%; height: 72%; object-fit: contain; }
  .bff-cycle-icon.is-bumble img { width: 82%; height: 82%; }
  .bff-locked-copy { animation: bff-copy-lock-in 620ms cubic-bezier(.18,.84,.22,1) both; }
  .bff-final-headline {
    font-size: clamp(36px, 4.4vw, 58px) !important;
    font-weight: 820 !important;
    line-height: .98 !important;
  }
  .bff-final-headline .selective-handwriting {
    font-size: 1.18em;
  }
  .bff-real-ui { background: #fff; }
  .bff-screen { position: absolute; inset: 0; overflow: hidden; color: #171717; background: #fff; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; }
  .bff-screen.is-focused-post::after {
    position: absolute;
    inset: 0;
    z-index: 5;
    background: rgba(255,255,255,.68);
    backdrop-filter: blur(2.5px);
    content: '';
    opacity: 0;
    pointer-events: none;
    animation: bff-focus-overlay 420ms 2480ms ease forwards;
  }
  .bff-room-header { display: grid; grid-template-columns: 22px 34px 1fr 22px; align-items: center; gap: 6px; height: 52px; padding: 0 10px; border-bottom: 1px solid #eee; box-sizing: border-box; }
  .bff-room-header button { border: 0; padding: 0; background: transparent; font-size: 30px; font-weight: 300; line-height: 1; }
  .bff-room-header > img { width: 32px; height: 32px; border-radius: 10px; object-fit: cover; }
  .bff-room-header > div { display: grid; justify-items: center; gap: 2px; }
  .bff-room-header strong { font-size: 12px; font-weight: 750; }
  .bff-room-header strong b { position: relative; top: -2px; display: inline-block; font-size: 11px; font-weight: 600; line-height: 1; }
  .bff-room-header small { display: flex; align-items: center; gap: 5px; color: #999; font-size: 8px; }
  .bff-room-header small i { width: 6px; height: 6px; border-radius: 50%; background: #00a400; }
  .bff-room-header > svg { width: 22px; height: 22px; color: #f45b9c; fill: #f45b9c; stroke-width: 1.5; }
  .bff-new-banner { display: flex; align-items: center; justify-content: space-between; height: 29px; padding: 0 11px; color: #fff; background: #1098f7; box-sizing: border-box; }
  .bff-new-banner strong { font-size: 10px; }
  .bff-new-banner span { font-size: 18px; font-weight: 300; }
  .bff-thread { position: absolute; top: 81px; right: 0; bottom: 78px; left: 0; overflow: hidden; padding: 3px 11px 7px; box-sizing: border-box; }
  .bff-thread.has-sent > * { animation: bff-thread-latest 520ms 1980ms cubic-bezier(.18,.84,.22,1) forwards; }
  .bff-thread-message { display: grid; grid-template-columns: 31px 1fr; align-items: start; gap: 7px; margin: 6px 0; }
  .bff-thread-message > img { width: 28px; height: 28px; border-radius: 50%; object-fit: cover; }
  .bff-thread-message > div { display: grid; justify-items: start; gap: 1px; min-width: 0; }
  .bff-thread-message strong { font-size: 10px; line-height: 1.1; }
  .bff-thread-message small { color: #999; font-size: 7px; }
  .bff-thread-message p { max-width: 218px; margin: 2px 0 0; padding: 0; background: transparent; font-size: 9px; line-height: 1.25; }
  .bff-reply-pill { display: block; width: 174px; margin-top: 4px; padding: 6px 9px; overflow: hidden; border: 1px solid #d4d4d4; border-radius: 14px; color: #8c8c8c; font-size: 8px; line-height: 1; white-space: nowrap; text-overflow: ellipsis; box-sizing: border-box; }
  .bff-new-divider { display: grid; grid-template-columns: auto 1fr; align-items: center; gap: 9px; margin: 8px 0; color: #ec2e65; }
  .bff-new-divider strong { font-size: 9px; }
  .bff-new-divider i { height: 1px; background: #f3d9e1; }

.bff-thread-message.is-mass {
  position: relative;
  z-index: 6;
  margin-top: -34px;
  opacity: 0;
  animation: bff-mass-in 440ms 2050ms
    cubic-bezier(.18,.84,.22,1) forwards;
}
  .bff-screen.is-focused-post .bff-thread-message.is-mass > div {
    transform-origin: left center;
    animation: bff-post-focus 420ms 2500ms
      cubic-bezier(.18,.84,.22,1) forwards;
  }
      .bff-thread-message.is-mass p { padding: 6px 8px; border-radius: 4px 11px 11px 11px; background: #fff0f6; }
  .bff-welcome-strip { position: absolute; right: 0; bottom: 34px; left: 0; display: grid; grid-template-columns: 22px 1fr 19px; align-items: start; gap: 5px; min-height: 44px; padding: 7px 10px; color: #fff; background: #f45b9c; box-sizing: border-box; }
  .bff-welcome-strip > span { font-size: 15px; }
  .bff-welcome-strip > div { display: grid; gap: 3px; }
  .bff-welcome-strip strong { font-size: 9px; }
  .bff-welcome-strip small { font-size: 8px; }
  .bff-welcome-strip > b { display: grid; place-items: center; width: 18px; height: 18px; border: 1.5px solid #fff; border-radius: 50%; font-size: 11px; }
  .bff-composer { position: absolute; right: 0; bottom: 0; left: 0; display: grid; grid-template-columns: 22px 1fr 17px 24px 19px 15px; align-items: center; gap: 4px; height: 34px; padding: 0 8px; background: #fff; box-sizing: border-box; }
  .bff-composer button { display: grid; place-items: center; width: 22px; height: 22px; border: 0; border-radius: 50%; padding: 0; color: #fff; background: #f45b9c; font-size: 17px; line-height: 1; }
  .bff-composer span { height: 25px; padding: 7px 9px; overflow: hidden; border-radius: 14px; color: #999; background: #f7f7f7; font-size: 8px; line-height: 1; white-space: nowrap; box-sizing: border-box; }
  .bff-composer span small { display: block; width: 0; overflow: hidden; font-size: 7px; line-height: 1; white-space: nowrap; animation: bff-composer-type 1550ms 260ms steps(48, end) forwards, bff-composer-clear 180ms 1900ms ease forwards; }
  .bff-composer b { color: #f45b9c; font-size: 17px; }
  .bff-composer i { display: grid; place-items: center; width: 25px; height: 20px; border-radius: 4px; color: #fff; background: #f45b9c; font-size: 7px; font-style: normal; font-weight: 850; }
  .bff-composer em { color: #f45b9c; font-size: 17px; font-style: normal; }
  .bff-composer > strong { color: #f45b9c; font-size: 15px; }
  @keyframes real-copy-in { from { opacity: 0; transform: translateY(17px); } to { opacity: 1; transform: translateY(0); } }
  @keyframes real-copy-word-in { to { opacity: 1; transform: translateY(0); } }
  @keyframes real-ui-in { from { opacity: 0; transform: translateX(22px) scale(.985); } to { opacity: 1; transform: translateX(0) scale(1); } }
  @keyframes ig-message-send { from { opacity: 0; transform: translateY(10px) scale(.96); } to { opacity: 1; transform: translateY(0) scale(1); } }
  @keyframes ig-query-type { to { width: 78px; } }
  @keyframes ig-results-in { to { opacity: 1; } }
  @keyframes ig-results-scroll { 0%,18% { transform: translateY(0); } 78%,100% { transform: translateY(-126px); } }
  @keyframes ig-target-open {
    0%,100% { transform: scale(1); }
    55% { transform: scale(.96); background: #ededed; }
  }
  @keyframes ig-search-community-open {
    to { opacity: 1; transform: translateX(0); }
  }
  @keyframes ig-community-page-scroll { 0%,18% { transform: translateY(0); } 82%,100% { transform: translateY(-82px); } }
  @keyframes ig-followers-scroll { 0%,18% { transform: translateY(0); } 82%,100% { transform: translateY(-126px); } }
  @keyframes ig-message-button-focus { 0%,100% { transform: scale(1); } 50% { transform: scale(.94); background: #dedede; } }
  @keyframes ig-profile-row-select {
    0% { background: transparent; transform: scale(1); }
    55% { background: #ededed; transform: scale(.985); }
    100% { background: #f7f7f7; transform: scale(1); }
  }
  @keyframes ig-profile-button-press {
    0%,100% { transform: scale(1); }
    50% { transform: scale(.9); }
  }
  @keyframes ig-selected-profile-open {
    to { opacity: 1; transform: translateX(0); }
  }
  @keyframes instagram-category-phrase-in {
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes instagram-category-flip {
    0% { opacity: 0; transform: translateY(.42em); }
    18%, 76% { opacity: 1; transform: translateY(0); }
    100% { opacity: 0; transform: translateY(-.38em); }
  }
  @keyframes instagram-category-flip-last {
    0% { opacity: 0; transform: translateY(.42em); }
    22%, 100% { opacity: 1; transform: translateY(0); }
  }
  @keyframes instagram-category-scene-in {
    from { opacity: 0; transform: translateY(15px) scale(.99); }
    to { opacity: 1; transform: translateY(0) scale(1); }
  }
  @keyframes instagram-category-copy-left {
    from { opacity: 0; transform: translateX(12vw); }
    to { opacity: 1; transform: translateX(0); }
  }
  @keyframes bff-profile-card-in {
    from { opacity: 0; transform: translateY(12px) scale(.985); }
    to { opacity: 1; transform: translateY(0) scale(1); }
  }
  @keyframes bff-wave-button-in {
    from { opacity: 0; transform: translateY(10px) scale(.75); }
    to { opacity: 1; transform: translateY(0) scale(1); }
  }
  @keyframes bff-discover-feed-scroll {
    0%,16% { transform: translateY(0); }
    35%,49% { transform: translateY(-384px); }
    70%,100% { transform: translateY(-768px); }
  }
  @keyframes bff-connected-away {
    to { opacity: 0; visibility: hidden; transform: scale(.985); }
  }
  @keyframes bff-chat-message-in {
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes bff-mass-in { from { opacity: 0; transform: translateY(13px); } to { opacity: 1; transform: translateY(0); } }
  @keyframes bff-focus-overlay { to { opacity: 1; } }
  @keyframes bff-post-focus { to { transform: scale(1.045); } }
  @keyframes bff-note-write { to { width: 124px; } }
  @keyframes bff-note-arrow-in { to { opacity: 1; } }
  @keyframes bff-copy-lock-in { from { opacity: 0; transform: translateX(80px); } to { opacity: 1; transform: translateX(0); } }
  @keyframes bff-invitation-icon-in { to { opacity: 1; transform: translateY(0) rotate(-2deg) scale(1); } }
  @keyframes bff-invitation-icon-send { 0% { opacity: 1; transform: translateX(0) rotate(-2deg) scale(1); } 18% { transform: translateX(-8px) rotate(-4deg) scale(1); } 100% { opacity: 0; transform: translateX(285px) rotate(7deg) scale(.92); } }
  @keyframes bff-invitation-streak { 0% { opacity: 0; transform: scaleX(.25); } 25%, 72% { opacity: .8; transform: scaleX(1); } 100% { opacity: 0; transform: scaleX(.35); } }
  @keyframes bff-ui-after-copy { to { opacity: 1; transform: translateX(0); } }
  @keyframes bff-cycle-shell-in { to { opacity: 1; transform: translateY(0) rotate(-1deg) scale(1); } }
  @keyframes bff-destination-cycle { 0% { opacity: 0; transform: translateY(.48em); } 16%, 76% { opacity: 1; transform: translateY(0); } 100% { opacity: 0; transform: translateY(-.48em); } }
  @keyframes bff-destination-last { to { opacity: 1; transform: translateY(0); } }
  @keyframes bff-composer-type { to { width: 245px; } }
  @keyframes bff-composer-clear { to { opacity: 0; } }
  @keyframes bff-thread-latest { to { transform: translateY(-42px); } }

  .platform-method-opening,
  .direct-personal-opening {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 42px;
    padding: 42px;
    box-sizing: border-box;
  }

  .platform-method-opening .where-word-reveal {
    max-width: 930px;
  }

  .method-logo-row {
    display: flex;
    align-items: center;
    gap: 34px;
  }

  .method-logo-row img {
    width: 45px;
    height: 45px;
    object-fit: contain;
    opacity: 0;
    transform: translateY(16px) scale(.82);
    animation: method-logo-in 480ms cubic-bezier(.18,.84,.22,1) forwards;
  }

  .method-logo-row img:nth-child(1) { animation-delay: 420ms; }
  .method-logo-row img:nth-child(2) { animation-delay: 560ms; }
  .method-logo-row img:nth-child(3) { width: 54px; height: 54px; animation-delay: 700ms; }

  .integrated-app-scene {
    position: absolute;
    inset: 0;
    display: grid;
    grid-template-columns: minmax(300px, .92fr) minmax(390px, 1.08fr);
    align-items: center;
    gap: clamp(36px, 6vw, 88px);
    padding: 36px clamp(32px, 6vw, 92px);
    box-sizing: border-box;
  }

  .integrated-app-scene.is-reversed {
    grid-template-columns: minmax(390px, 1.08fr) minmax(300px, .92fr);
  }

  .integrated-app-scene.is-reversed .integrated-app-copy { order: 2; }
  .integrated-app-scene.is-reversed .integrated-app-visual { order: 1; }
  .integrated-app-copy { position: relative; z-index: 2; }
  .integrated-app-copy .where-word-reveal {
    max-width: 570px;
    font-size: clamp(34px, 4.4vw, 59px);
    text-align: left;
  }

  .integrated-app-visual {
    position: relative;
    display: grid;
    align-items: center;
    min-width: 0;
    opacity: 0;
    transform: translateX(26px) scale(.97);
    animation: app-fragment-in 650ms 220ms cubic-bezier(.18,.84,.22,1) forwards;
  }

  .integrated-app-scene.is-reversed .integrated-app-visual {
    transform: translateX(-26px) scale(.97);
  }

  .kinetic-search-fragment,
  .kinetic-community-fragment,
  .kinetic-people-list,
  .kinetic-maya-profile,
  .kinetic-dm-fragment,
  .kinetic-bumble-match {
    width: min(440px, 100%);
    justify-self: center;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 22px 60px rgba(0,0,0,.1);
  }

  .kinetic-search-fragment { padding: 20px; box-sizing: border-box; border-radius: 22px; }
  .kinetic-search-brand { display: flex; align-items: center; gap: 9px; margin-bottom: 16px; }
  .kinetic-search-brand img { width: 24px; height: 24px; object-fit: contain; }
  .kinetic-search-brand strong { font-size: 12px; }
  .kinetic-search-field { display: flex; align-items: center; gap: 9px; height: 42px; padding: 0 13px; border-radius: 11px; background: #f1f1f1; font-size: 12px; }
  .kinetic-search-field svg { width: 16px; }
  .kinetic-search-result { display: grid; grid-template-columns: 48px 1fr; align-items: center; gap: 12px; padding: 18px 4px 4px; }
  .kinetic-search-result > span { display: grid; place-items: center; width: 45px; height: 45px; border: 2px solid #c52db0; border-radius: 50%; font-size: 11px; font-weight: 950; }
  .kinetic-search-result > div { display: grid; gap: 4px; }
  .kinetic-search-result strong { font-size: 12px; }
  .kinetic-search-result small { color: #777; font-size: 9px; }

  .kinetic-community-fragment { border-radius: 20px; }
  .kinetic-community-head { display: grid; grid-template-columns: 54px 1fr; align-items: center; gap: 12px; padding: 17px; }
  .kinetic-community-head > span { display: grid; place-items: center; width: 51px; height: 51px; border-radius: 50%; color: #fff; background: #111; font-size: 12px; font-weight: 950; }
  .kinetic-community-head > div { display: grid; gap: 4px; }
  .kinetic-community-head strong { font-size: 12px; }
  .kinetic-community-head small { color: #777; font-size: 9px; }
  .kinetic-community-fragment .instagram-photo-grid { max-height: 190px; overflow: hidden; }
  .kinetic-community-people { display: flex; align-items: center; gap: 8px; padding: 13px 16px; font-size: 9px; }
  .kinetic-community-people svg { width: 15px; }

  .kinetic-people-list { display: grid; padding: 12px 16px; border-radius: 20px; box-sizing: border-box; }
  .kinetic-prospect-row { display: grid; grid-template-columns: 48px 1fr auto; align-items: center; gap: 11px; min-height: 69px; transition: opacity 300ms ease, transform 300ms ease; }
  .kinetic-prospect-row.is-muted { opacity: .28; transform: scale(.97); }
  .kinetic-prospect-row > img,
  .kinetic-prospect-row > span { display: grid; place-items: center; width: 45px; height: 45px; object-fit: cover; border-radius: 50%; background: #eee; font-size: 9px; font-weight: 900; }
  .kinetic-prospect-row > div { display: grid; gap: 3px; }
  .kinetic-prospect-row strong { font-size: 11px; }
  .kinetic-prospect-row small { color: #777; font-size: 9px; }
  .kinetic-prospect-row button { padding: 7px 15px; border: 0; border-radius: 8px; color: #fff; background: #0095f6; font-size: 9px; font-weight: 850; }
  .kinetic-prospect-row.is-selected { position: relative; }
  .kinetic-prospect-row.is-selected::after { content: ''; position: absolute; inset: 5px -7px; z-index: -1; border-radius: 13px; background: #f4f4f4; }

  .kinetic-maya-profile { border-radius: 20px; }
  .kinetic-maya-head { display: grid; grid-template-columns: 74px 1fr; align-items: center; gap: 15px; padding: 17px; }
  .kinetic-maya-head > img { width: 72px; height: 72px; object-fit: cover; border-radius: 50%; }
  .kinetic-maya-head > div { display: grid; gap: 4px; font-size: 10px; }
  .kinetic-maya-head strong { font-size: 12px; }
  .kinetic-maya-head strong small { color: #777; font-size: 9px; font-weight: 500; }
  .kinetic-maya-profile > button { display: flex; align-items: center; justify-content: center; gap: 7px; width: calc(100% - 34px); height: 32px; margin: 0 17px 12px; border: 0; border-radius: 8px; font-size: 10px; font-weight: 850; }
  .kinetic-maya-profile > button svg { width: 13px; }
  .kinetic-maya-profile .instagram-photo-grid { max-height: 182px; overflow: hidden; }

  .kinetic-dm-fragment { display: grid; gap: 16px; padding: 20px; border-radius: 22px; box-sizing: border-box; }
  .kinetic-dm-head { display: flex; align-items: center; gap: 10px; }
  .kinetic-dm-head img { width: 39px; height: 39px; object-fit: cover; border-radius: 50%; }
  .kinetic-dm-head strong { font-size: 11px; }
  .kinetic-dm-bubble { justify-self: end; max-width: 300px; padding: 12px 14px; border-radius: 18px 18px 4px 18px; color: #fff; background: #3797f0; font-size: 9px; line-height: 1.45; }
  .kinetic-dm-sent { display: flex; justify-content: flex-end; align-items: center; gap: 6px; color: #777; font-size: 8px; }
  .kinetic-dm-sent svg { width: 11px; }

  .kinetic-bumble-match { display: grid; justify-items: center; gap: 10px; padding: 22px; border-radius: 22px; box-sizing: border-box; text-align: center; }
  .bumble-match-logo { width: 48px; height: 48px; object-fit: contain; }
  .bumble-match-person { width: 105px; height: 105px; object-fit: cover; border: 5px solid #ffc629; border-radius: 50%; }
  .kinetic-bumble-match > div { display: grid; gap: 4px; }
  .kinetic-bumble-match strong { font-size: 14px; }
  .kinetic-bumble-match small { color: #777; font-size: 9px; }
  .kinetic-bumble-match button { width: 100%; height: 35px; margin-top: 5px; border: 0; border-radius: 18px; background: #ffc629; font-size: 10px; font-weight: 900; }

  .direct-personal-opening { gap: 38px; }
  .direct-personal-line { display: flex; align-items: center; justify-content: center; flex-wrap: wrap; gap: 14px; max-width: 1050px; }
  .direct-personal-line .where-word-reveal { width: auto; font-size: clamp(40px, 5.4vw, 72px); }
  .selected-person-chip { display: flex; align-items: center; gap: 9px; padding: 7px 15px 7px 7px; border-radius: 40px; background: #111; color: #fff; opacity: 0; transform: scale(.82); animation: chip-in 480ms 420ms cubic-bezier(.18,.84,.22,1) forwards; }
  .selected-person-chip img { width: 44px; height: 44px; object-fit: cover; border-radius: 50%; }
  .selected-person-chip strong { font-size: clamp(18px, 2.3vw, 29px); }
  .personal-message-chip { display: flex; align-items: center; gap: 10px; color: #666; font-size: 13px; opacity: 0; animation: method-logo-in 460ms 900ms ease forwards; }
  .personal-message-chip svg { width: 22px; }

  .bumble-integrated-warning {
    position: absolute;
    inset: 0;
    display: grid;
    grid-template-columns: minmax(310px, .9fr) minmax(390px, 1.1fr);
    align-items: center;
    gap: clamp(40px, 6vw, 90px);
    padding: 34px clamp(32px, 6vw, 90px);
    box-sizing: border-box;
  }
  .bumble-warning-copy { display: grid; gap: 14px; }
  .bumble-warning-copy .where-word-reveal { font-size: clamp(34px, 4.4vw, 58px); text-align: left; }
  .bumble-integrated-warning .bumble-chat { justify-self: center; }

  .kinetic-composition {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 42px clamp(28px, 6vw, 90px);
    box-sizing: border-box;
  }

  .kinetic-sentence {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 14px 18px;
    max-width: 1120px;
    font-size: clamp(36px, 5.1vw, 69px);
    font-weight: 950;
    letter-spacing: -.065em;
    line-height: .98;
  }

  .kinetic-sentence-center { justify-content: center; text-align: center; }
  .inline-kinetic-words { display: inline; }
  .inline-kinetic-words > span {
    display: inline-block;
    opacity: 0;
    transform: translateY(.34em);
    animation: intro-word-in 360ms cubic-bezier(.18,.84,.22,1) forwards;
    animation-delay: var(--word-delay);
  }

  .inline-logo-cluster {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    margin: 0 3px;
  }
  .inline-logo-cluster img {
    width: 48px;
    height: 48px;
    object-fit: contain;
    opacity: 0;
    transform: translateY(12px) scale(.75);
    animation: method-logo-in 460ms cubic-bezier(.18,.84,.22,1) forwards;
  }
  .inline-logo-cluster img:nth-child(1) { animation-delay: 170ms; }
  .inline-logo-cluster img:nth-child(2) { animation-delay: 280ms; }
  .inline-logo-cluster img:nth-child(3) { width: 57px; height: 57px; animation-delay: 390ms; }

  .named-platform {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
    opacity: 0;
    transform: scale(.82);
    animation: chip-in 460ms 180ms cubic-bezier(.18,.84,.22,1) forwards;
  }
  .named-platform img { width: .78em; height: .78em; object-fit: contain; }
  .named-platform.bumble-name img { width: .92em; height: .92em; }

  .search-composition { flex-direction: column; }
  .sentence-search-control {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 17px;
    width: 100%;
    max-width: 1080px;
    margin-top: 18px;
    font-size: clamp(32px, 4.2vw, 57px);
    font-weight: 950;
    letter-spacing: -.055em;
    line-height: 1;
  }
  .sentence-search-control > div {
    display: flex;
    align-items: center;
    gap: 10px;
    width: min(330px, 80vw);
    height: 58px;
    padding: 0 17px;
    color: #555;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0;
    background: #f1f1f1;
    border-radius: 14px;
    box-sizing: border-box;
    opacity: 0;
    transform: scaleX(.8);
    animation: search-control-in 520ms 500ms cubic-bezier(.18,.84,.22,1) forwards;
  }
  .sentence-search-control svg { width: 19px; flex: 0 0 auto; }

  .people-composition,
  .prospect-composition,
  .profile-composition,
  .message-composition,
  .bumble-composition,
  .mass-post-composition,
  .promotional-composition { flex-direction: column; gap: 28px; }

  .inline-people-stack {
    position: relative;
    display: inline-block;
    width: 174px;
    height: 58px;
    vertical-align: middle;
  }
  .inline-people-stack img {
    position: absolute;
    left: calc(var(--person-index) * 31px);
    width: 54px;
    height: 54px;
    object-fit: cover;
    border: 3px solid #fff;
    border-radius: 50%;
    opacity: 0;
    transform: translateX(15px) scale(.8);
    animation: known-avatar-in 460ms cubic-bezier(.18,.84,.22,1) forwards;
    animation-delay: calc(220ms + var(--person-index) * 90ms);
  }
  .community-context-chip {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 9px 15px;
    color: #666;
    font-size: 12px;
    font-weight: 800;
    opacity: 0;
    animation: method-logo-in 450ms 850ms ease forwards;
  }
  .community-context-chip svg { width: 17px; }

  .maya-prospect-pill {
    display: inline-grid;
    grid-template-columns: 52px auto 27px;
    align-items: center;
    gap: 10px;
    padding: 7px 11px 7px 7px;
    color: #111;
    background: #f2f2f2;
    border-radius: 36px;
    opacity: 0;
    transform: translateY(15px) rotate(-2deg);
    animation: prospect-pill-in 520ms 450ms cubic-bezier(.18,.84,.22,1) forwards;
  }
  .maya-prospect-pill > img { width: 52px; height: 52px; object-fit: cover; border-radius: 50%; }
  .maya-prospect-pill > span { display: grid; gap: 3px; text-align: left; letter-spacing: 0; }
  .maya-prospect-pill > span strong { font-size: 13px; }
  .maya-prospect-pill > span small { color: #777; font-size: 9px; font-weight: 600; }
  .maya-prospect-pill > b { display: grid; place-items: center; width: 25px; height: 25px; border-radius: 50%; color: #fff; background: #111; font-size: 11px; }

  .profile-sentence { justify-content: center; text-align: center; }
  .inline-maya-profile {
    display: inline-grid;
    grid-template-columns: 58px minmax(130px, 1fr) auto;
    align-items: center;
    gap: 11px;
    width: min(420px, 88vw);
    padding: 10px;
    background: #fff;
    border-radius: 19px;
    box-shadow: 0 18px 48px rgba(0,0,0,.11);
    opacity: 0;
    transform: translateY(18px) scale(.94);
    animation: prospect-pill-in 560ms 420ms cubic-bezier(.18,.84,.22,1) forwards;
  }
  .inline-maya-profile > img { width: 58px; height: 58px; object-fit: cover; border-radius: 50%; }
  .inline-maya-profile > span { display: grid; gap: 4px; text-align: left; letter-spacing: 0; }
  .inline-maya-profile > span strong { font-size: 12px; }
  .inline-maya-profile > span strong small { color: #777; font-size: 9px; font-weight: 500; }
  .inline-maya-profile > span > small { color: #666; font-size: 9px; font-weight: 600; }
  .inline-maya-profile button { display: flex; align-items: center; gap: 5px; padding: 8px 11px; border: 0; border-radius: 8px; font-size: 9px; font-weight: 850; }
  .inline-maya-profile button svg { width: 12px; }

  .inline-dm-action {
    position: relative;
    display: inline-block;
    width: 78px;
    height: 62px;
    opacity: 0;
    transform: translateY(15px);
    animation: method-logo-in 470ms 360ms cubic-bezier(.18,.84,.22,1) forwards;
  }
  .inline-dm-action img { width: 60px; height: 60px; object-fit: cover; border-radius: 50%; }
  .inline-dm-action svg { position: absolute; right: 0; bottom: 0; width: 28px; height: 28px; padding: 7px; color: #fff; background: #0095f6; border: 3px solid #fff; border-radius: 50%; box-sizing: border-box; }
  .inline-message-bubble {
    max-width: 510px;
    padding: 13px 16px;
    border-radius: 19px 19px 5px 19px;
    color: #fff;
    background: #3797f0;
    font-size: 11px;
    line-height: 1.45;
    opacity: 0;
    transform: translateY(15px) scale(.96);
    animation: prospect-pill-in 520ms 900ms cubic-bezier(.18,.84,.22,1) forwards;
  }

  .inline-match-chip {
    display: inline-flex;
    align-items: center;
    gap: 9px;
    padding: 7px 14px 7px 7px;
    color: #111;
    background: #ffc629;
    border-radius: 35px;
    opacity: 0;
    transform: scale(.8) rotate(3deg);
    animation: chip-in 500ms 780ms cubic-bezier(.18,.84,.22,1) forwards;
  }
  .inline-match-chip img { width: 48px; height: 48px; object-fit: cover; border-radius: 50%; }
  .inline-match-chip strong { font-size: 11px; letter-spacing: .06em; }

  .inline-bumble-group {
    display: inline-grid;
    width: min(430px, 88vw);
    overflow: hidden;
    color: #111;
    background: #fff;
    border-radius: 19px;
    box-shadow: 0 20px 55px rgba(0,0,0,.11);
    font-size: initial;
    letter-spacing: 0;
    line-height: 1.3;
    text-align: left;
    opacity: 0;
    transform: translateY(18px) rotate(1deg);
    animation: prospect-pill-in 560ms 500ms cubic-bezier(.18,.84,.22,1) forwards;
  }
  .bumble-group-head { display: grid; grid-template-columns: 32px 1fr auto; align-items: center; gap: 9px; padding: 11px 13px; background: #ffc629; }
  .bumble-group-head img { width: 29px; height: 29px; object-fit: contain; }
  .bumble-group-head strong { font-size: 10px; }
  .bumble-group-head small { font-size: 8px; opacity: .6; }
  .bumble-group-message { display: grid; grid-template-columns: 34px 1fr; align-items: start; gap: 9px; padding: 15px; }
  .bumble-group-message b { display: grid; place-items: center; width: 31px; height: 31px; border-radius: 50%; background: #ffc629; font-size: 7px; }
  .bumble-group-message > span { padding: 9px 11px; border-radius: 4px 13px 13px 13px; background: #fff3c6; font-size: 9px; }

  .promotional-x {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px 18px;
    color: #fff;
    background: #111;
    transform: rotate(-2deg);
    opacity: 0;
    animation: promotional-in 520ms 320ms cubic-bezier(.18,.84,.22,1) forwards;
  }
  .promotional-x svg { width: .8em; height: .8em; margin-right: 8px; stroke-width: 2.4; }
  .promotional-x strong { font: inherit; }

  @keyframes method-logo-in { to { opacity: 1; transform: translateY(0) scale(1); } }
  @keyframes app-fragment-in { to { opacity: 1; transform: translateX(0) scale(1); } }
  @keyframes chip-in { to { opacity: 1; transform: scale(1); } }
  @keyframes search-control-in { to { opacity: 1; transform: scaleX(1); } }
  @keyframes prospect-pill-in { to { opacity: 1; transform: translateY(0) rotate(0) scale(1); } }
  @keyframes promotional-in { to { opacity: 1; transform: rotate(-2deg) scale(1); } }

  @keyframes where-platform-in { to { opacity: 1; transform: translateY(0); } }
  @keyframes intro-word-in { to { opacity: 1; transform: translateY(0); } }
  @keyframes intro-prospect-in { to { opacity: 1; transform: translate(calc(-50% + (var(--prospect-index) - 2) * 47px), -50%) scale(1); } }
  @keyframes intro-question-pop { from { opacity: 0; transform: scale(.5) rotate(-8deg); } to { opacity: 1; transform: scale(1) rotate(0); } }
  @keyframes intro-question-photo { from { opacity: .7; transform: rotate(calc((var(--question-index) - 2) * 8deg)) translateY(-25px) scale(1.4); } to { opacity: .2; transform: rotate(calc((var(--question-index) - 2) * 25deg)) translateY(-78px) scale(1); } }
  @keyframes cold-line-in { to { transform: scaleX(1); } }
  @keyframes cold-message-in { to { opacity: 1; transform: scale(1); } }
  @keyframes community-pulse { 0%,100% { transform: scale(1); } 50% { transform: scale(1.04); } }
  @keyframes inline-profile-in { to { opacity: 1; transform: translateX(0) rotate(calc((var(--prospect-index) - 1.5) * 4deg)); } }
  @keyframes inline-profile-out { to { opacity: 0; transform: translate(34px, 50px) scale(.35); } }
  @keyframes inline-icon-in { to { opacity: 1; transform: translateY(0) rotate(0) scale(1); } }
  @keyframes known-avatar-in { to { opacity: 1; transform: translateX(0) scale(1); } }
  @keyframes scan-copy-in { to { opacity: 1; transform: translate(0); } }
  @keyframes prospect-film-move { from { transform: translateX(0); } to { transform: translateX(-190px); } }
  @keyframes prospect-target-pulse { 50% { transform: translateX(-50%) scale(1.08); } to { transform: translateX(-50%) scale(1); } }
  @keyframes prospect-scan-away { to { opacity: 0; transform: translateY(-45px) scale(.92); } }
  @keyframes prospect-question-in { to { opacity: 1; transform: scale(1); } }
  @keyframes platform-name-roll { 0% { opacity: 0; transform: translateY(70px) rotate(4deg) scale(.8); } 22%, 70% { opacity: 1; transform: translateY(0) rotate(0) scale(1); } 100% { opacity: 0; transform: translateY(-65px) rotate(-3deg) scale(.9); } }
  @keyframes community-roll-in { to { opacity: 1; transform: translateY(0); } }
  @keyframes contact-copy-in { to { opacity: 1; transform: translateY(0); } }
  @keyframes contact-tile-in { to { opacity: 1; transform: translateX(0) rotate(calc((var(--contact-index) - 1.5) * 1.5deg)); } }
  @keyframes arrow-shoot-in { from { opacity: 0; transform: translateX(-35px); } to { opacity: 1; transform: translateX(0); } }
  @keyframes first-scene-enter {
    from { opacity: 0; transform: translate3d(7%, 18px, -35px) scale(.985); filter: blur(5px); }
    to { opacity: 1; transform: translate3d(0,0,0) scale(1); filter: blur(0); }
  }
  @keyframes first-scene-exit {
    from { opacity: 1; transform: translate3d(0,0,0) scale(1); filter: blur(0); }
    to { opacity: 0; transform: translate3d(-6%, -15px, -50px) scale(.97); filter: blur(5px); }
  }
  @keyframes living-profile-in { to { opacity: 1; transform: translateX(0) scale(1); } }
  @keyframes ideal-lockup-in { to { opacity: 1; transform: translateY(0) scale(1); } }
  @keyframes ideal-face-in { to { opacity: 1; transform: translateX(0) scale(1); } }
  @keyframes living-element-in { to { opacity: 1; transform: translateY(0) scale(1); } }
  @keyframes living-icon-pop { to { opacity: 1; transform: scale(1) rotate(0); } }
  @keyframes living-black-word-in { to { opacity: 1; transform: rotate(-1.2deg) scale(1); } }
  @keyframes other-platform-dot { 0%,100% { opacity: .35; transform: translateY(0); } 50% { opacity: 1; transform: translateY(-3px); } }
  @keyframes typing-bubble-in { to { opacity: 1; transform: translateY(0) scale(1); } }
  @keyframes living-typing-dot { 0%,60%,100% { opacity: .4; transform: translateY(0); } 30% { opacity: 1; transform: translateY(-5px); } }
  @keyframes where-caption-in { from { opacity: 0; transform: translateY(18px); } to { opacity: 1; transform: translateY(0); } }
  @keyframes instagram-screen-in { from { opacity: 0; transform: translateX(12px); } to { opacity: 1; transform: translateX(0); } }
  @keyframes instagram-query-in { to { width: 76px; } }
  @keyframes instagram-grid-scroll { from { transform: translateY(20px); } to { transform: translateY(-42px); } }
  @keyframes instagram-message-in { from { opacity: 0; transform: translateY(9px) scale(.96); } to { opacity: 1; transform: translateY(0) scale(1); } }
  @keyframes bumble-message-in { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }
  @keyframes bumble-overlay-in { from { opacity: 0; } to { opacity: 1; } }

  @media (max-width: 720px) {
    .where-slide { min-height: 570px; }
    .where-platform-intro { grid-template-columns: 1fr; align-content: center; gap: 42px; padding: 30px 22px; }
    .where-platform-copy h1 { font-size: 38px; }
    .where-platforms { gap: 18px; }
    .where-platform div { width: 66px; height: 66px; font-size: 39px; }
    .where-platform strong { font-size: 11px; }

    .where-walkthrough,
    .bumble-example {
      grid-template-columns: 1fr;
      grid-template-rows: auto 1fr;
      align-content: center;
      gap: 20px;
      padding: 22px 18px;
    }

    .where-walkthrough-copy h1,
    .bumble-copy h1 { max-width: 520px; font-size: 31px; }
    .where-phone-frame,
    .bumble-chat { height: 410px; }

    .integrated-app-scene,
    .integrated-app-scene.is-reversed,
    .bumble-integrated-warning {
      grid-template-columns: 1fr;
      grid-template-rows: auto 1fr;
      align-content: center;
      gap: 20px;
      padding: 24px 18px;
    }
    .integrated-app-scene.is-reversed .integrated-app-copy,
    .integrated-app-scene.is-reversed .integrated-app-visual { order: initial; }
    .integrated-app-copy .where-word-reveal,
    .bumble-warning-copy .where-word-reveal { font-size: 31px; text-align: center; }
    .kinetic-search-fragment,
    .kinetic-community-fragment,
    .kinetic-people-list,
    .kinetic-maya-profile,
    .kinetic-dm-fragment,
    .kinetic-bumble-match { max-height: 340px; }

    .prospect-scan-copy { flex-direction: column; align-items: center; gap: 4px; }
    .prospect-filmstrip { height: 86px; }
    .prospect-filmstrip img { flex-basis: 80px; width: 80px; height: 80px; }
    .prospect-filmstrip i { width: 80px; height: 80px; }
    .prospect-question-sequence { flex-direction: column; gap: 18px; text-align: center; }
    .prospect-search-lens { width: 85px; height: 85px; }
    .platform-rollcall { padding: 28px 18px; }
    .platform-rollcall-stage { height: 190px; }
    .platform-rollcall-item { flex-direction: column; gap: 5px; }
    .platform-rollcall-item strong { font-size: 52px; }
    .known-people-sequence { grid-template-columns: 1fr; grid-template-rows: auto 240px; gap: 20px; padding: 30px 22px; }
    .known-people-copy { text-align: center; }
    .known-people-copy strong { font-size: 49px; }
    .contact-tile-row { width: min(350px, 90vw); justify-self: center; }
    .one-to-one-final { gap: 32px; padding: 25px 16px; }
    .one-to-one-equation { gap: 20px; }
    .one-to-one-copy strong { font-size: 57px; }

    .living-sentence-scene { padding: 30px 19px; }
    .living-sentence { gap: 9px 11px; font-size: 39px; }
    .opening-statement { gap: 9px 11px; font-size: 39px; }
    .ideal-prospect-lockup { gap: 8px; padding: 7px 8px 7px 12px; }
    .ideal-prospect-lockup > strong { font-size: .7em; }
    .ideal-prospect-lockup img { width: 36px; height: 36px; }
    .standalone-question { font-size: 57px; }
    .living-profile-word { min-height: 53px; padding-left: 94px; }
    .living-profile-word img { left: calc(var(--living-index) * 23px); width: 42px; height: 42px; }
    .living-platform-sentence { font-size: 29px; }
    .living-platform-word { gap: 5px; }
    .living-la-word,
    .living-contacts-word { padding: 6px 10px; }
    .living-final-sentence > .inline-kinetic-words:last-child { font-size: 1.12em; }
    .instagram-search-statement { gap: 10px; padding-right: 16px; padding-left: 16px; }
    .instagram-search-statement > .where-word-reveal { font-size: 34px; }
    .inline-relevant-communities { width: 100%; }
    .inline-relevant-communities .where-word-reveal {
      white-space: normal;
    }

    .real-app-lesson {
      grid-template-columns: 1fr;
      grid-template-rows: auto 1fr;
      align-content: center;
      gap: 18px;
      padding: 22px 18px;
    }
    .real-app-copy { justify-items: center; text-align: center; gap: 8px; }
    .real-app-copy h1 { font-size: 31px; }
    .real-app-copy p { max-width: 520px; font-size: 11px; }
    .instagram-category-scene,
    .instagram-category-scene.has-instagram-ui {
      grid-template-columns: 1fr;
      grid-template-rows: auto 1fr;
      align-content: center;
      gap: 18px;
      padding: 22px 18px;
    }
    .instagram-category-copy-wrap,
    .has-instagram-ui .instagram-category-copy-wrap {
      justify-items: center;
    }
    .instagram-category-copy,
    .has-instagram-ui .instagram-category-copy {
      width: min(540px, 100%);
      justify-content: center;
      flex-wrap: wrap;
      font-size: 31px;
      text-align: center;
    }
    .instagram-category-flip {
      width: 100%;
      height: 1.08em;
    }
    .instagram-category-flip > strong {
      right: 0;
      text-align: center;
    }
    .has-instagram-ui .instagram-category-copy {
      font-size: 23px;
    }
    .has-instagram-ui .instagram-category-cue {
      font-size: 22px;
    }
    .instagram-real-ui,
    .bff-real-ui { height: 385px; }
    .instagram-category-ui { height: 340px; }
    .bff-demo-wrap {
      width: min(250px, 100%);
      height: 385px;
    }
    .bff-static-note {
      top: 154px;
      right: -6px;
      transform: rotate(2deg);
    }
    .bff-static-note strong { font-size: 16px; }
    .bff-static-note svg {
      width: 74px;
      height: 54px;
      margin-left: 4px;
    }
    .ig-dm-thread { height: 137px; }
  }

  @media (prefers-reduced-motion: reduce) {
    .where-slide,
    .where-slide * {
      animation-duration: .01ms !important;
      animation-delay: 0ms !important;
      transition-duration: .01ms !important;
    }
  }
`;
